/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleProtobuf000 from '@ngx-grpc/well-known-types';
import * as googleType001 from '../../../../external/mercury/v1/shared/google/type/decimal.pb';
import * as booking_platformV1Shared002 from '../../../../external/mercury/v1/shared/geolocation.pb';
import * as booking_platformV1Shared003 from '../../../../external/mercury/v1/shared/auto-complete-result-item.pb';
import * as booking_platformV1Shared004 from '../../../../external/mercury/v1/shared/seat.pb';
export enum AutocompleteCategory {
  EVENT = 0,
  EVENT_LOCATION = 1,
  EVENT_VENUE = 2,
  EVENT_PERFORMER = 3
}
export enum SearchType {
  SEARCHTYPE_LOCATION = 0,
  SEARCHTYPE_EVENT = 1,
  SEARCHTYPE_PERFORMER = 2,
  SEARCHTYPE_VENUE = 3
}
export enum SearchCategory {
  CONCERT = 0,
  ART_AND_THEATER = 1,
  SPORT = 2,
  FAMILY = 3
}
export enum AvailabilityStatus {
  UNAVAILABLE = 0,
  AVAILABLE = 1,
  ON_REQUEST = 2
}
/**
 * Message implementation for booking_platform.v1.entertainment.AutocompleteRequest
 */
export class AutocompleteRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.AutocompleteRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutocompleteRequest();
    AutocompleteRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutocompleteRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.categories = _instance.categories || [];
    _instance.searchString = _instance.searchString || '';
    _instance.geolocation = _instance.geolocation || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutocompleteRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.categories = _instance.categories || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 6:
          _instance.searchString = _reader.readString();
          break;
        case 7:
          _instance.geolocation = new booking_platformV1Shared002.Geolocation();
          _reader.readMessage(
            _instance.geolocation,
            booking_platformV1Shared002.Geolocation.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutocompleteRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutocompleteRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.categories && _instance.categories.length) {
      _writer.writePackedEnum(5, _instance.categories);
    }
    if (_instance.searchString) {
      _writer.writeString(6, _instance.searchString);
    }
    if (_instance.geolocation) {
      _writer.writeMessage(
        7,
        _instance.geolocation as any,
        booking_platformV1Shared002.Geolocation.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _categories: AutocompleteCategory[];
  private _searchString: string;
  private _geolocation?: booking_platformV1Shared002.Geolocation;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutocompleteRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<AutocompleteRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.categories = (_value.categories || []).slice();
    this.searchString = _value.searchString;
    this.geolocation = _value.geolocation
      ? new booking_platformV1Shared002.Geolocation(_value.geolocation)
      : undefined;
    AutocompleteRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get categories(): AutocompleteCategory[] {
    return this._categories;
  }
  set categories(value: AutocompleteCategory[]) {
    this._categories = value;
  }
  get searchString(): string {
    return this._searchString;
  }
  set searchString(value: string) {
    this._searchString = value;
  }
  get geolocation(): booking_platformV1Shared002.Geolocation | undefined {
    return this._geolocation;
  }
  set geolocation(value: booking_platformV1Shared002.Geolocation | undefined) {
    this._geolocation = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutocompleteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutocompleteRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      categories: (this.categories || []).slice(),
      searchString: this.searchString,
      geolocation: this.geolocation ? this.geolocation.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutocompleteRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      categories: (this.categories || []).map(v => AutocompleteCategory[v]),
      searchString: this.searchString,
      geolocation: this.geolocation
        ? this.geolocation.toProtobufJSON(options)
        : null
    };
  }
}
export module AutocompleteRequest {
  /**
   * Standard JavaScript object representation for AutocompleteRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    categories: AutocompleteCategory[];
    searchString: string;
    geolocation?: booking_platformV1Shared002.Geolocation.AsObject;
  }

  /**
   * Protobuf JSON representation for AutocompleteRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    categories: string[];
    searchString: string;
    geolocation: booking_platformV1Shared002.Geolocation.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.AutoCompleteResponse
 */
export class AutoCompleteResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.AutoCompleteResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutoCompleteResponse();
    AutoCompleteResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutoCompleteResponse) {
    _instance.categories = _instance.categories || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutoCompleteResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new AutoCompleteResultByCategory();
          _reader.readMessage(
            messageInitializer1,
            AutoCompleteResultByCategory.deserializeBinaryFromReader
          );
          (_instance.categories = _instance.categories || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutoCompleteResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutoCompleteResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.categories && _instance.categories.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.categories as any,
        AutoCompleteResultByCategory.serializeBinaryToWriter
      );
    }
  }

  private _categories?: AutoCompleteResultByCategory[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutoCompleteResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<AutoCompleteResponse.AsObject>) {
    _value = _value || {};
    this.categories = (_value.categories || []).map(
      m => new AutoCompleteResultByCategory(m)
    );
    AutoCompleteResponse.refineValues(this);
  }
  get categories(): AutoCompleteResultByCategory[] | undefined {
    return this._categories;
  }
  set categories(value: AutoCompleteResultByCategory[] | undefined) {
    this._categories = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutoCompleteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutoCompleteResponse.AsObject {
    return {
      categories: (this.categories || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutoCompleteResponse.AsProtobufJSON {
    return {
      categories: (this.categories || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AutoCompleteResponse {
  /**
   * Standard JavaScript object representation for AutoCompleteResponse
   */
  export interface AsObject {
    categories?: AutoCompleteResultByCategory.AsObject[];
  }

  /**
   * Protobuf JSON representation for AutoCompleteResponse
   */
  export interface AsProtobufJSON {
    categories: AutoCompleteResultByCategory.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.AutoCompleteResultByCategory
 */
export class AutoCompleteResultByCategory implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.AutoCompleteResultByCategory';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AutoCompleteResultByCategory();
    AutoCompleteResultByCategory.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AutoCompleteResultByCategory) {
    _instance.category = _instance.category || 0;
    _instance.results = _instance.results || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AutoCompleteResultByCategory,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.category = _reader.readEnum();
          break;
        case 2:
          const messageInitializer2 = new booking_platformV1Shared003.AutoCompleteResultItem();
          _reader.readMessage(
            messageInitializer2,
            booking_platformV1Shared003.AutoCompleteResultItem
              .deserializeBinaryFromReader
          );
          (_instance.results = _instance.results || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AutoCompleteResultByCategory.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AutoCompleteResultByCategory,
    _writer: BinaryWriter
  ) {
    if (_instance.category) {
      _writer.writeEnum(1, _instance.category);
    }
    if (_instance.results && _instance.results.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.results as any,
        booking_platformV1Shared003.AutoCompleteResultItem
          .serializeBinaryToWriter
      );
    }
  }

  private _category: AutocompleteCategory;
  private _results?: booking_platformV1Shared003.AutoCompleteResultItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AutoCompleteResultByCategory to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<AutoCompleteResultByCategory.AsObject>
  ) {
    _value = _value || {};
    this.category = _value.category;
    this.results = (_value.results || []).map(
      m => new booking_platformV1Shared003.AutoCompleteResultItem(m)
    );
    AutoCompleteResultByCategory.refineValues(this);
  }
  get category(): AutocompleteCategory {
    return this._category;
  }
  set category(value: AutocompleteCategory) {
    this._category = value;
  }
  get results():
    | booking_platformV1Shared003.AutoCompleteResultItem[]
    | undefined {
    return this._results;
  }
  set results(
    value: booking_platformV1Shared003.AutoCompleteResultItem[] | undefined
  ) {
    this._results = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AutoCompleteResultByCategory.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AutoCompleteResultByCategory.AsObject {
    return {
      category: this.category,
      results: (this.results || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AutoCompleteResultByCategory.AsProtobufJSON {
    return {
      category:
        AutocompleteCategory[
          this.category === null || this.category === undefined
            ? 0
            : this.category
        ],
      results: (this.results || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module AutoCompleteResultByCategory {
  /**
   * Standard JavaScript object representation for AutoCompleteResultByCategory
   */
  export interface AsObject {
    category: AutocompleteCategory;
    results?: booking_platformV1Shared003.AutoCompleteResultItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for AutoCompleteResultByCategory
   */
  export interface AsProtobufJSON {
    category: string;
    results:
      | booking_platformV1Shared003.AutoCompleteResultItem.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.VenueInfoRequest
 */
export class VenueInfoRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.VenueInfoRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueInfoRequest();
    VenueInfoRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueInfoRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.venueIds = _instance.venueIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueInfoRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.venueIds = _instance.venueIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    VenueInfoRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueInfoRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.venueIds && _instance.venueIds.length) {
      _writer.writePackedInt32(5, _instance.venueIds);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _venueIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueInfoRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueInfoRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.venueIds = (_value.venueIds || []).slice();
    VenueInfoRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get venueIds(): number[] {
    return this._venueIds;
  }
  set venueIds(value: number[]) {
    this._venueIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueInfoRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      venueIds: (this.venueIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueInfoRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      venueIds: (this.venueIds || []).slice()
    };
  }
}
export module VenueInfoRequest {
  /**
   * Standard JavaScript object representation for VenueInfoRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    venueIds: number[];
  }

  /**
   * Protobuf JSON representation for VenueInfoRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    venueIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.VenueInfoResponse
 */
export class VenueInfoResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.VenueInfoResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueInfoResponse();
    VenueInfoResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueInfoResponse) {
    _instance.venues = _instance.venues || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueInfoResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new VenueInfoEntity();
          _reader.readMessage(
            messageInitializer1,
            VenueInfoEntity.deserializeBinaryFromReader
          );
          (_instance.venues = _instance.venues || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    VenueInfoResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueInfoResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.venues && _instance.venues.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.venues as any,
        VenueInfoEntity.serializeBinaryToWriter
      );
    }
  }

  private _venues?: VenueInfoEntity[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueInfoResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueInfoResponse.AsObject>) {
    _value = _value || {};
    this.venues = (_value.venues || []).map(m => new VenueInfoEntity(m));
    VenueInfoResponse.refineValues(this);
  }
  get venues(): VenueInfoEntity[] | undefined {
    return this._venues;
  }
  set venues(value: VenueInfoEntity[] | undefined) {
    this._venues = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueInfoResponse.AsObject {
    return {
      venues: (this.venues || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueInfoResponse.AsProtobufJSON {
    return {
      venues: (this.venues || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module VenueInfoResponse {
  /**
   * Standard JavaScript object representation for VenueInfoResponse
   */
  export interface AsObject {
    venues?: VenueInfoEntity.AsObject[];
  }

  /**
   * Protobuf JSON representation for VenueInfoResponse
   */
  export interface AsProtobufJSON {
    venues: VenueInfoEntity.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.VenueInfoEntity
 */
export class VenueInfoEntity implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.VenueInfoEntity';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new VenueInfoEntity();
    VenueInfoEntity.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: VenueInfoEntity) {
    _instance.venueId = _instance.venueId || 0;
    _instance.venueName = _instance.venueName || '';
    _instance.venueLocation = _instance.venueLocation || '';
    _instance.mainImageUrl = _instance.mainImageUrl || undefined;
    _instance.venueAddress = _instance.venueAddress || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: VenueInfoEntity,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.venueId = _reader.readInt32();
          break;
        case 2:
          _instance.venueName = _reader.readString();
          break;
        case 3:
          _instance.venueLocation = _reader.readString();
          break;
        case 4:
          _instance.mainImageUrl = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.mainImageUrl,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.venueAddress = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.venueAddress,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    VenueInfoEntity.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: VenueInfoEntity,
    _writer: BinaryWriter
  ) {
    if (_instance.venueId) {
      _writer.writeInt32(1, _instance.venueId);
    }
    if (_instance.venueName) {
      _writer.writeString(2, _instance.venueName);
    }
    if (_instance.venueLocation) {
      _writer.writeString(3, _instance.venueLocation);
    }
    if (_instance.mainImageUrl) {
      _writer.writeMessage(
        4,
        _instance.mainImageUrl as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.venueAddress) {
      _writer.writeMessage(
        5,
        _instance.venueAddress as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _venueId: number;
  private _venueName: string;
  private _venueLocation: string;
  private _mainImageUrl?: googleProtobuf000.StringValue;
  private _venueAddress?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of VenueInfoEntity to deeply clone from
   */
  constructor(_value?: RecursivePartial<VenueInfoEntity.AsObject>) {
    _value = _value || {};
    this.venueId = _value.venueId;
    this.venueName = _value.venueName;
    this.venueLocation = _value.venueLocation;
    this.mainImageUrl = _value.mainImageUrl
      ? new googleProtobuf000.StringValue(_value.mainImageUrl)
      : undefined;
    this.venueAddress = _value.venueAddress
      ? new googleProtobuf000.StringValue(_value.venueAddress)
      : undefined;
    VenueInfoEntity.refineValues(this);
  }
  get venueId(): number {
    return this._venueId;
  }
  set venueId(value: number) {
    this._venueId = value;
  }
  get venueName(): string {
    return this._venueName;
  }
  set venueName(value: string) {
    this._venueName = value;
  }
  get venueLocation(): string {
    return this._venueLocation;
  }
  set venueLocation(value: string) {
    this._venueLocation = value;
  }
  get mainImageUrl(): googleProtobuf000.StringValue | undefined {
    return this._mainImageUrl;
  }
  set mainImageUrl(value: googleProtobuf000.StringValue | undefined) {
    this._mainImageUrl = value;
  }
  get venueAddress(): googleProtobuf000.StringValue | undefined {
    return this._venueAddress;
  }
  set venueAddress(value: googleProtobuf000.StringValue | undefined) {
    this._venueAddress = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    VenueInfoEntity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): VenueInfoEntity.AsObject {
    return {
      venueId: this.venueId,
      venueName: this.venueName,
      venueLocation: this.venueLocation,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toObject()
        : undefined,
      venueAddress: this.venueAddress ? this.venueAddress.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): VenueInfoEntity.AsProtobufJSON {
    return {
      venueId: this.venueId,
      venueName: this.venueName,
      venueLocation: this.venueLocation,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toProtobufJSON(options)
        : null,
      venueAddress: this.venueAddress
        ? this.venueAddress.toProtobufJSON(options)
        : null
    };
  }
}
export module VenueInfoEntity {
  /**
   * Standard JavaScript object representation for VenueInfoEntity
   */
  export interface AsObject {
    venueId: number;
    venueName: string;
    venueLocation: string;
    mainImageUrl?: googleProtobuf000.StringValue.AsObject;
    venueAddress?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for VenueInfoEntity
   */
  export interface AsProtobufJSON {
    venueId: number;
    venueName: string;
    venueLocation: string;
    mainImageUrl: googleProtobuf000.StringValue.AsProtobufJSON | null;
    venueAddress: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.EventInfoRequest
 */
export class EventInfoRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.EventInfoRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EventInfoRequest();
    EventInfoRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EventInfoRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.eventIds = _instance.eventIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EventInfoRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.eventIds = _instance.eventIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    EventInfoRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EventInfoRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.eventIds && _instance.eventIds.length) {
      _writer.writePackedInt32(5, _instance.eventIds);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _eventIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EventInfoRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<EventInfoRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.eventIds = (_value.eventIds || []).slice();
    EventInfoRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get eventIds(): number[] {
    return this._eventIds;
  }
  set eventIds(value: number[]) {
    this._eventIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EventInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EventInfoRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      eventIds: (this.eventIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EventInfoRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      eventIds: (this.eventIds || []).slice()
    };
  }
}
export module EventInfoRequest {
  /**
   * Standard JavaScript object representation for EventInfoRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    eventIds: number[];
  }

  /**
   * Protobuf JSON representation for EventInfoRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    eventIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.EventInfoResponse
 */
export class EventInfoResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.EventInfoResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EventInfoResponse();
    EventInfoResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EventInfoResponse) {
    _instance.events = _instance.events || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EventInfoResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new EventInfoEntity();
          _reader.readMessage(
            messageInitializer1,
            EventInfoEntity.deserializeBinaryFromReader
          );
          (_instance.events = _instance.events || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    EventInfoResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EventInfoResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.events && _instance.events.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.events as any,
        EventInfoEntity.serializeBinaryToWriter
      );
    }
  }

  private _events?: EventInfoEntity[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EventInfoResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<EventInfoResponse.AsObject>) {
    _value = _value || {};
    this.events = (_value.events || []).map(m => new EventInfoEntity(m));
    EventInfoResponse.refineValues(this);
  }
  get events(): EventInfoEntity[] | undefined {
    return this._events;
  }
  set events(value: EventInfoEntity[] | undefined) {
    this._events = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EventInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EventInfoResponse.AsObject {
    return {
      events: (this.events || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EventInfoResponse.AsProtobufJSON {
    return {
      events: (this.events || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module EventInfoResponse {
  /**
   * Standard JavaScript object representation for EventInfoResponse
   */
  export interface AsObject {
    events?: EventInfoEntity.AsObject[];
  }

  /**
   * Protobuf JSON representation for EventInfoResponse
   */
  export interface AsProtobufJSON {
    events: EventInfoEntity.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.EventInfoEntity
 */
export class EventInfoEntity implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.EventInfoEntity';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EventInfoEntity();
    EventInfoEntity.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EventInfoEntity) {
    _instance.eventId = _instance.eventId || 0;
    _instance.eventName = _instance.eventName || '';
    _instance.venueName = _instance.venueName || '';
    _instance.venueLocation = _instance.venueLocation || '';
    _instance.mainImageUrl = _instance.mainImageUrl || undefined;
    _instance.venueAddress = _instance.venueAddress || undefined;
    _instance.performers = _instance.performers || [];
    _instance.attributeIds = _instance.attributeIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EventInfoEntity,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.eventId = _reader.readInt32();
          break;
        case 2:
          _instance.eventName = _reader.readString();
          break;
        case 3:
          _instance.venueName = _reader.readString();
          break;
        case 4:
          _instance.venueLocation = _reader.readString();
          break;
        case 5:
          _instance.mainImageUrl = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.mainImageUrl,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.venueAddress = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.venueAddress,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 7:
          const messageInitializer7 = new Performer();
          _reader.readMessage(
            messageInitializer7,
            Performer.deserializeBinaryFromReader
          );
          (_instance.performers = _instance.performers || []).push(
            messageInitializer7
          );
          break;
        case 8:
          (_instance.attributeIds = _instance.attributeIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    EventInfoEntity.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EventInfoEntity,
    _writer: BinaryWriter
  ) {
    if (_instance.eventId) {
      _writer.writeInt32(1, _instance.eventId);
    }
    if (_instance.eventName) {
      _writer.writeString(2, _instance.eventName);
    }
    if (_instance.venueName) {
      _writer.writeString(3, _instance.venueName);
    }
    if (_instance.venueLocation) {
      _writer.writeString(4, _instance.venueLocation);
    }
    if (_instance.mainImageUrl) {
      _writer.writeMessage(
        5,
        _instance.mainImageUrl as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.venueAddress) {
      _writer.writeMessage(
        6,
        _instance.venueAddress as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.performers && _instance.performers.length) {
      _writer.writeRepeatedMessage(
        7,
        _instance.performers as any,
        Performer.serializeBinaryToWriter
      );
    }
    if (_instance.attributeIds && _instance.attributeIds.length) {
      _writer.writePackedInt32(8, _instance.attributeIds);
    }
  }

  private _eventId: number;
  private _eventName: string;
  private _venueName: string;
  private _venueLocation: string;
  private _mainImageUrl?: googleProtobuf000.StringValue;
  private _venueAddress?: googleProtobuf000.StringValue;
  private _performers?: Performer[];
  private _attributeIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EventInfoEntity to deeply clone from
   */
  constructor(_value?: RecursivePartial<EventInfoEntity.AsObject>) {
    _value = _value || {};
    this.eventId = _value.eventId;
    this.eventName = _value.eventName;
    this.venueName = _value.venueName;
    this.venueLocation = _value.venueLocation;
    this.mainImageUrl = _value.mainImageUrl
      ? new googleProtobuf000.StringValue(_value.mainImageUrl)
      : undefined;
    this.venueAddress = _value.venueAddress
      ? new googleProtobuf000.StringValue(_value.venueAddress)
      : undefined;
    this.performers = (_value.performers || []).map(m => new Performer(m));
    this.attributeIds = (_value.attributeIds || []).slice();
    EventInfoEntity.refineValues(this);
  }
  get eventId(): number {
    return this._eventId;
  }
  set eventId(value: number) {
    this._eventId = value;
  }
  get eventName(): string {
    return this._eventName;
  }
  set eventName(value: string) {
    this._eventName = value;
  }
  get venueName(): string {
    return this._venueName;
  }
  set venueName(value: string) {
    this._venueName = value;
  }
  get venueLocation(): string {
    return this._venueLocation;
  }
  set venueLocation(value: string) {
    this._venueLocation = value;
  }
  get mainImageUrl(): googleProtobuf000.StringValue | undefined {
    return this._mainImageUrl;
  }
  set mainImageUrl(value: googleProtobuf000.StringValue | undefined) {
    this._mainImageUrl = value;
  }
  get venueAddress(): googleProtobuf000.StringValue | undefined {
    return this._venueAddress;
  }
  set venueAddress(value: googleProtobuf000.StringValue | undefined) {
    this._venueAddress = value;
  }
  get performers(): Performer[] | undefined {
    return this._performers;
  }
  set performers(value: Performer[] | undefined) {
    this._performers = value;
  }
  get attributeIds(): number[] {
    return this._attributeIds;
  }
  set attributeIds(value: number[]) {
    this._attributeIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EventInfoEntity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EventInfoEntity.AsObject {
    return {
      eventId: this.eventId,
      eventName: this.eventName,
      venueName: this.venueName,
      venueLocation: this.venueLocation,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toObject()
        : undefined,
      venueAddress: this.venueAddress
        ? this.venueAddress.toObject()
        : undefined,
      performers: (this.performers || []).map(m => m.toObject()),
      attributeIds: (this.attributeIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EventInfoEntity.AsProtobufJSON {
    return {
      eventId: this.eventId,
      eventName: this.eventName,
      venueName: this.venueName,
      venueLocation: this.venueLocation,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toProtobufJSON(options)
        : null,
      venueAddress: this.venueAddress
        ? this.venueAddress.toProtobufJSON(options)
        : null,
      performers: (this.performers || []).map(m => m.toProtobufJSON(options)),
      attributeIds: (this.attributeIds || []).slice()
    };
  }
}
export module EventInfoEntity {
  /**
   * Standard JavaScript object representation for EventInfoEntity
   */
  export interface AsObject {
    eventId: number;
    eventName: string;
    venueName: string;
    venueLocation: string;
    mainImageUrl?: googleProtobuf000.StringValue.AsObject;
    venueAddress?: googleProtobuf000.StringValue.AsObject;
    performers?: Performer.AsObject[];
    attributeIds: number[];
  }

  /**
   * Protobuf JSON representation for EventInfoEntity
   */
  export interface AsProtobufJSON {
    eventId: number;
    eventName: string;
    venueName: string;
    venueLocation: string;
    mainImageUrl: googleProtobuf000.StringValue.AsProtobufJSON | null;
    venueAddress: googleProtobuf000.StringValue.AsProtobufJSON | null;
    performers: Performer.AsProtobufJSON[] | null;
    attributeIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SearchRequest
 */
export class SearchRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.SearchRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchRequest();
    SearchRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.locationId = _instance.locationId || 0;
    _instance.eventId = _instance.eventId || undefined;
    _instance.performerId = _instance.performerId || undefined;
    _instance.venueId = _instance.venueId || undefined;
    _instance.startDate = _instance.startDate || undefined;
    _instance.endDate = _instance.endDate || undefined;
    _instance.searchCategories = _instance.searchCategories || [];
    _instance.pageSize = _instance.pageSize || 0;
    _instance.languageCode = _instance.languageCode || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.locationId = _reader.readInt32();
          break;
        case 5:
          _instance.eventId = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.eventId,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.performerId = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.performerId,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.venueId = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.venueId,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.startDate = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.startDate,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.endDate = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.endDate,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 10:
          (_instance.searchCategories = _instance.searchCategories || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 11:
          _instance.pageSize = _reader.readInt32();
          break;
        case 12:
          _instance.languageCode = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.languageCode,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.locationId) {
      _writer.writeInt32(4, _instance.locationId);
    }
    if (_instance.eventId) {
      _writer.writeMessage(
        5,
        _instance.eventId as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.performerId) {
      _writer.writeMessage(
        6,
        _instance.performerId as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.venueId) {
      _writer.writeMessage(
        7,
        _instance.venueId as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.startDate) {
      _writer.writeMessage(
        8,
        _instance.startDate as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.endDate) {
      _writer.writeMessage(
        9,
        _instance.endDate as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.searchCategories && _instance.searchCategories.length) {
      _writer.writePackedEnum(10, _instance.searchCategories);
    }
    if (_instance.pageSize) {
      _writer.writeInt32(11, _instance.pageSize);
    }
    if (_instance.languageCode) {
      _writer.writeMessage(
        12,
        _instance.languageCode as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _locationId: number;
  private _eventId?: googleProtobuf000.Int32Value;
  private _performerId?: googleProtobuf000.Int32Value;
  private _venueId?: googleProtobuf000.Int32Value;
  private _startDate?: googleProtobuf000.StringValue;
  private _endDate?: googleProtobuf000.StringValue;
  private _searchCategories: SearchCategory[];
  private _pageSize: number;
  private _languageCode?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.locationId = _value.locationId;
    this.eventId = _value.eventId
      ? new googleProtobuf000.Int32Value(_value.eventId)
      : undefined;
    this.performerId = _value.performerId
      ? new googleProtobuf000.Int32Value(_value.performerId)
      : undefined;
    this.venueId = _value.venueId
      ? new googleProtobuf000.Int32Value(_value.venueId)
      : undefined;
    this.startDate = _value.startDate
      ? new googleProtobuf000.StringValue(_value.startDate)
      : undefined;
    this.endDate = _value.endDate
      ? new googleProtobuf000.StringValue(_value.endDate)
      : undefined;
    this.searchCategories = (_value.searchCategories || []).slice();
    this.pageSize = _value.pageSize;
    this.languageCode = _value.languageCode
      ? new googleProtobuf000.StringValue(_value.languageCode)
      : undefined;
    SearchRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get locationId(): number {
    return this._locationId;
  }
  set locationId(value: number) {
    this._locationId = value;
  }
  get eventId(): googleProtobuf000.Int32Value | undefined {
    return this._eventId;
  }
  set eventId(value: googleProtobuf000.Int32Value | undefined) {
    this._eventId = value;
  }
  get performerId(): googleProtobuf000.Int32Value | undefined {
    return this._performerId;
  }
  set performerId(value: googleProtobuf000.Int32Value | undefined) {
    this._performerId = value;
  }
  get venueId(): googleProtobuf000.Int32Value | undefined {
    return this._venueId;
  }
  set venueId(value: googleProtobuf000.Int32Value | undefined) {
    this._venueId = value;
  }
  get startDate(): googleProtobuf000.StringValue | undefined {
    return this._startDate;
  }
  set startDate(value: googleProtobuf000.StringValue | undefined) {
    this._startDate = value;
  }
  get endDate(): googleProtobuf000.StringValue | undefined {
    return this._endDate;
  }
  set endDate(value: googleProtobuf000.StringValue | undefined) {
    this._endDate = value;
  }
  get searchCategories(): SearchCategory[] {
    return this._searchCategories;
  }
  set searchCategories(value: SearchCategory[]) {
    this._searchCategories = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }
  get languageCode(): googleProtobuf000.StringValue | undefined {
    return this._languageCode;
  }
  set languageCode(value: googleProtobuf000.StringValue | undefined) {
    this._languageCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      locationId: this.locationId,
      eventId: this.eventId ? this.eventId.toObject() : undefined,
      performerId: this.performerId ? this.performerId.toObject() : undefined,
      venueId: this.venueId ? this.venueId.toObject() : undefined,
      startDate: this.startDate ? this.startDate.toObject() : undefined,
      endDate: this.endDate ? this.endDate.toObject() : undefined,
      searchCategories: (this.searchCategories || []).slice(),
      pageSize: this.pageSize,
      languageCode: this.languageCode ? this.languageCode.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      locationId: this.locationId,
      eventId: this.eventId ? this.eventId.toProtobufJSON(options) : null,
      performerId: this.performerId
        ? this.performerId.toProtobufJSON(options)
        : null,
      venueId: this.venueId ? this.venueId.toProtobufJSON(options) : null,
      startDate: this.startDate ? this.startDate.toProtobufJSON(options) : null,
      endDate: this.endDate ? this.endDate.toProtobufJSON(options) : null,
      searchCategories: (this.searchCategories || []).map(
        v => SearchCategory[v]
      ),
      pageSize: this.pageSize,
      languageCode: this.languageCode
        ? this.languageCode.toProtobufJSON(options)
        : null
    };
  }
}
export module SearchRequest {
  /**
   * Standard JavaScript object representation for SearchRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    locationId: number;
    eventId?: googleProtobuf000.Int32Value.AsObject;
    performerId?: googleProtobuf000.Int32Value.AsObject;
    venueId?: googleProtobuf000.Int32Value.AsObject;
    startDate?: googleProtobuf000.StringValue.AsObject;
    endDate?: googleProtobuf000.StringValue.AsObject;
    searchCategories: SearchCategory[];
    pageSize: number;
    languageCode?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for SearchRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    locationId: number;
    eventId: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    performerId: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    venueId: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    startDate: googleProtobuf000.StringValue.AsProtobufJSON | null;
    endDate: googleProtobuf000.StringValue.AsProtobufJSON | null;
    searchCategories: string[];
    pageSize: number;
    languageCode: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SearchResponse
 */
export class SearchResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.SearchResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchResponse();
    SearchResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchResponse) {
    _instance.numberOfResults = _instance.numberOfResults || 0;
    _instance.pageSize = _instance.pageSize || 0;
    _instance.results = _instance.results || [];
    _instance.extendedResults = _instance.extendedResults || [];
    _instance.searchToken = _instance.searchToken || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.numberOfResults = _reader.readInt32();
          break;
        case 2:
          _instance.pageSize = _reader.readInt32();
          break;
        case 3:
          const messageInitializer3 = new PerformanceResult();
          _reader.readMessage(
            messageInitializer3,
            PerformanceResult.deserializeBinaryFromReader
          );
          (_instance.results = _instance.results || []).push(
            messageInitializer3
          );
          break;
        case 4:
          const messageInitializer4 = new PerformanceResult();
          _reader.readMessage(
            messageInitializer4,
            PerformanceResult.deserializeBinaryFromReader
          );
          (_instance.extendedResults = _instance.extendedResults || []).push(
            messageInitializer4
          );
          break;
        case 5:
          _instance.searchToken = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    SearchResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.numberOfResults) {
      _writer.writeInt32(1, _instance.numberOfResults);
    }
    if (_instance.pageSize) {
      _writer.writeInt32(2, _instance.pageSize);
    }
    if (_instance.results && _instance.results.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.results as any,
        PerformanceResult.serializeBinaryToWriter
      );
    }
    if (_instance.extendedResults && _instance.extendedResults.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.extendedResults as any,
        PerformanceResult.serializeBinaryToWriter
      );
    }
    if (_instance.searchToken) {
      _writer.writeString(5, _instance.searchToken);
    }
  }

  private _numberOfResults: number;
  private _pageSize: number;
  private _results?: PerformanceResult[];
  private _extendedResults?: PerformanceResult[];
  private _searchToken: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchResponse.AsObject>) {
    _value = _value || {};
    this.numberOfResults = _value.numberOfResults;
    this.pageSize = _value.pageSize;
    this.results = (_value.results || []).map(m => new PerformanceResult(m));
    this.extendedResults = (_value.extendedResults || []).map(
      m => new PerformanceResult(m)
    );
    this.searchToken = _value.searchToken;
    SearchResponse.refineValues(this);
  }
  get numberOfResults(): number {
    return this._numberOfResults;
  }
  set numberOfResults(value: number) {
    this._numberOfResults = value;
  }
  get pageSize(): number {
    return this._pageSize;
  }
  set pageSize(value: number) {
    this._pageSize = value;
  }
  get results(): PerformanceResult[] | undefined {
    return this._results;
  }
  set results(value: PerformanceResult[] | undefined) {
    this._results = value;
  }
  get extendedResults(): PerformanceResult[] | undefined {
    return this._extendedResults;
  }
  set extendedResults(value: PerformanceResult[] | undefined) {
    this._extendedResults = value;
  }
  get searchToken(): string {
    return this._searchToken;
  }
  set searchToken(value: string) {
    this._searchToken = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchResponse.AsObject {
    return {
      numberOfResults: this.numberOfResults,
      pageSize: this.pageSize,
      results: (this.results || []).map(m => m.toObject()),
      extendedResults: (this.extendedResults || []).map(m => m.toObject()),
      searchToken: this.searchToken
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchResponse.AsProtobufJSON {
    return {
      numberOfResults: this.numberOfResults,
      pageSize: this.pageSize,
      results: (this.results || []).map(m => m.toProtobufJSON(options)),
      extendedResults: (this.extendedResults || []).map(m =>
        m.toProtobufJSON(options)
      ),
      searchToken: this.searchToken
    };
  }
}
export module SearchResponse {
  /**
   * Standard JavaScript object representation for SearchResponse
   */
  export interface AsObject {
    numberOfResults: number;
    pageSize: number;
    results?: PerformanceResult.AsObject[];
    extendedResults?: PerformanceResult.AsObject[];
    searchToken: string;
  }

  /**
   * Protobuf JSON representation for SearchResponse
   */
  export interface AsProtobufJSON {
    numberOfResults: number;
    pageSize: number;
    results: PerformanceResult.AsProtobufJSON[] | null;
    extendedResults: PerformanceResult.AsProtobufJSON[] | null;
    searchToken: string;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SearchPaginationRequest
 */
export class SearchPaginationRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.SearchPaginationRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchPaginationRequest();
    SearchPaginationRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchPaginationRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.searchToken = _instance.searchToken || '';
    _instance.pageIndex = _instance.pageIndex || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchPaginationRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.searchToken = _reader.readString();
          break;
        case 5:
          _instance.pageIndex = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    SearchPaginationRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchPaginationRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.searchToken) {
      _writer.writeString(4, _instance.searchToken);
    }
    if (_instance.pageIndex) {
      _writer.writeInt32(5, _instance.pageIndex);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _searchToken: string;
  private _pageIndex: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchPaginationRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchPaginationRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.searchToken = _value.searchToken;
    this.pageIndex = _value.pageIndex;
    SearchPaginationRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get searchToken(): string {
    return this._searchToken;
  }
  set searchToken(value: string) {
    this._searchToken = value;
  }
  get pageIndex(): number {
    return this._pageIndex;
  }
  set pageIndex(value: number) {
    this._pageIndex = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchPaginationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchPaginationRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      searchToken: this.searchToken,
      pageIndex: this.pageIndex
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchPaginationRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      searchToken: this.searchToken,
      pageIndex: this.pageIndex
    };
  }
}
export module SearchPaginationRequest {
  /**
   * Standard JavaScript object representation for SearchPaginationRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    searchToken: string;
    pageIndex: number;
  }

  /**
   * Protobuf JSON representation for SearchPaginationRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    searchToken: string;
    pageIndex: number;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SearchPaginationResponse
 */
export class SearchPaginationResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.SearchPaginationResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchPaginationResponse();
    SearchPaginationResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchPaginationResponse) {
    _instance.results = _instance.results || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchPaginationResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PerformanceResult();
          _reader.readMessage(
            messageInitializer1,
            PerformanceResult.deserializeBinaryFromReader
          );
          (_instance.results = _instance.results || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchPaginationResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchPaginationResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.results && _instance.results.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.results as any,
        PerformanceResult.serializeBinaryToWriter
      );
    }
  }

  private _results?: PerformanceResult[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchPaginationResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchPaginationResponse.AsObject>) {
    _value = _value || {};
    this.results = (_value.results || []).map(m => new PerformanceResult(m));
    SearchPaginationResponse.refineValues(this);
  }
  get results(): PerformanceResult[] | undefined {
    return this._results;
  }
  set results(value: PerformanceResult[] | undefined) {
    this._results = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchPaginationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchPaginationResponse.AsObject {
    return {
      results: (this.results || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchPaginationResponse.AsProtobufJSON {
    return {
      results: (this.results || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module SearchPaginationResponse {
  /**
   * Standard JavaScript object representation for SearchPaginationResponse
   */
  export interface AsObject {
    results?: PerformanceResult.AsObject[];
  }

  /**
   * Protobuf JSON representation for SearchPaginationResponse
   */
  export interface AsProtobufJSON {
    results: PerformanceResult.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.PerformanceResult
 */
export class PerformanceResult implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.PerformanceResult';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerformanceResult();
    PerformanceResult.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerformanceResult) {
    _instance.performanceId = _instance.performanceId || 0;
    _instance.date = _instance.date || '';
    _instance.time = _instance.time || '';
    _instance.eventName = _instance.eventName || '';
    _instance.eventId = _instance.eventId || 0;
    _instance.performers = _instance.performers || [];
    _instance.venueName = _instance.venueName || '';
    _instance.venueId = _instance.venueId || 0;
    _instance.locationName = _instance.locationName || '';
    _instance.locationId = _instance.locationId || 0;
    _instance.attributeIds = _instance.attributeIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerformanceResult,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.performanceId = _reader.readInt32();
          break;
        case 2:
          _instance.date = _reader.readString();
          break;
        case 3:
          _instance.time = _reader.readString();
          break;
        case 4:
          _instance.eventName = _reader.readString();
          break;
        case 5:
          _instance.eventId = _reader.readInt32();
          break;
        case 6:
          const messageInitializer6 = new Performer();
          _reader.readMessage(
            messageInitializer6,
            Performer.deserializeBinaryFromReader
          );
          (_instance.performers = _instance.performers || []).push(
            messageInitializer6
          );
          break;
        case 7:
          _instance.venueName = _reader.readString();
          break;
        case 8:
          _instance.venueId = _reader.readInt32();
          break;
        case 9:
          _instance.locationName = _reader.readString();
          break;
        case 10:
          _instance.locationId = _reader.readInt32();
          break;
        case 11:
          (_instance.attributeIds = _instance.attributeIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PerformanceResult.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerformanceResult,
    _writer: BinaryWriter
  ) {
    if (_instance.performanceId) {
      _writer.writeInt32(1, _instance.performanceId);
    }
    if (_instance.date) {
      _writer.writeString(2, _instance.date);
    }
    if (_instance.time) {
      _writer.writeString(3, _instance.time);
    }
    if (_instance.eventName) {
      _writer.writeString(4, _instance.eventName);
    }
    if (_instance.eventId) {
      _writer.writeInt32(5, _instance.eventId);
    }
    if (_instance.performers && _instance.performers.length) {
      _writer.writeRepeatedMessage(
        6,
        _instance.performers as any,
        Performer.serializeBinaryToWriter
      );
    }
    if (_instance.venueName) {
      _writer.writeString(7, _instance.venueName);
    }
    if (_instance.venueId) {
      _writer.writeInt32(8, _instance.venueId);
    }
    if (_instance.locationName) {
      _writer.writeString(9, _instance.locationName);
    }
    if (_instance.locationId) {
      _writer.writeInt32(10, _instance.locationId);
    }
    if (_instance.attributeIds && _instance.attributeIds.length) {
      _writer.writePackedInt32(11, _instance.attributeIds);
    }
  }

  private _performanceId: number;
  private _date: string;
  private _time: string;
  private _eventName: string;
  private _eventId: number;
  private _performers?: Performer[];
  private _venueName: string;
  private _venueId: number;
  private _locationName: string;
  private _locationId: number;
  private _attributeIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerformanceResult to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerformanceResult.AsObject>) {
    _value = _value || {};
    this.performanceId = _value.performanceId;
    this.date = _value.date;
    this.time = _value.time;
    this.eventName = _value.eventName;
    this.eventId = _value.eventId;
    this.performers = (_value.performers || []).map(m => new Performer(m));
    this.venueName = _value.venueName;
    this.venueId = _value.venueId;
    this.locationName = _value.locationName;
    this.locationId = _value.locationId;
    this.attributeIds = (_value.attributeIds || []).slice();
    PerformanceResult.refineValues(this);
  }
  get performanceId(): number {
    return this._performanceId;
  }
  set performanceId(value: number) {
    this._performanceId = value;
  }
  get date(): string {
    return this._date;
  }
  set date(value: string) {
    this._date = value;
  }
  get time(): string {
    return this._time;
  }
  set time(value: string) {
    this._time = value;
  }
  get eventName(): string {
    return this._eventName;
  }
  set eventName(value: string) {
    this._eventName = value;
  }
  get eventId(): number {
    return this._eventId;
  }
  set eventId(value: number) {
    this._eventId = value;
  }
  get performers(): Performer[] | undefined {
    return this._performers;
  }
  set performers(value: Performer[] | undefined) {
    this._performers = value;
  }
  get venueName(): string {
    return this._venueName;
  }
  set venueName(value: string) {
    this._venueName = value;
  }
  get venueId(): number {
    return this._venueId;
  }
  set venueId(value: number) {
    this._venueId = value;
  }
  get locationName(): string {
    return this._locationName;
  }
  set locationName(value: string) {
    this._locationName = value;
  }
  get locationId(): number {
    return this._locationId;
  }
  set locationId(value: number) {
    this._locationId = value;
  }
  get attributeIds(): number[] {
    return this._attributeIds;
  }
  set attributeIds(value: number[]) {
    this._attributeIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerformanceResult.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerformanceResult.AsObject {
    return {
      performanceId: this.performanceId,
      date: this.date,
      time: this.time,
      eventName: this.eventName,
      eventId: this.eventId,
      performers: (this.performers || []).map(m => m.toObject()),
      venueName: this.venueName,
      venueId: this.venueId,
      locationName: this.locationName,
      locationId: this.locationId,
      attributeIds: (this.attributeIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerformanceResult.AsProtobufJSON {
    return {
      performanceId: this.performanceId,
      date: this.date,
      time: this.time,
      eventName: this.eventName,
      eventId: this.eventId,
      performers: (this.performers || []).map(m => m.toProtobufJSON(options)),
      venueName: this.venueName,
      venueId: this.venueId,
      locationName: this.locationName,
      locationId: this.locationId,
      attributeIds: (this.attributeIds || []).slice()
    };
  }
}
export module PerformanceResult {
  /**
   * Standard JavaScript object representation for PerformanceResult
   */
  export interface AsObject {
    performanceId: number;
    date: string;
    time: string;
    eventName: string;
    eventId: number;
    performers?: Performer.AsObject[];
    venueName: string;
    venueId: number;
    locationName: string;
    locationId: number;
    attributeIds: number[];
  }

  /**
   * Protobuf JSON representation for PerformanceResult
   */
  export interface AsProtobufJSON {
    performanceId: number;
    date: string;
    time: string;
    eventName: string;
    eventId: number;
    performers: Performer.AsProtobufJSON[] | null;
    venueName: string;
    venueId: number;
    locationName: string;
    locationId: number;
    attributeIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.Performer
 */
export class Performer implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.Performer';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Performer();
    Performer.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Performer) {
    _instance.performerName = _instance.performerName || '';
    _instance.performerId = _instance.performerId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: Performer,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.performerName = _reader.readString();
          break;
        case 2:
          _instance.performerId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    Performer.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Performer, _writer: BinaryWriter) {
    if (_instance.performerName) {
      _writer.writeString(1, _instance.performerName);
    }
    if (_instance.performerId) {
      _writer.writeInt32(2, _instance.performerId);
    }
  }

  private _performerName: string;
  private _performerId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Performer to deeply clone from
   */
  constructor(_value?: RecursivePartial<Performer.AsObject>) {
    _value = _value || {};
    this.performerName = _value.performerName;
    this.performerId = _value.performerId;
    Performer.refineValues(this);
  }
  get performerName(): string {
    return this._performerName;
  }
  set performerName(value: string) {
    this._performerName = value;
  }
  get performerId(): number {
    return this._performerId;
  }
  set performerId(value: number) {
    this._performerId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Performer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Performer.AsObject {
    return {
      performerName: this.performerName,
      performerId: this.performerId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Performer.AsProtobufJSON {
    return {
      performerName: this.performerName,
      performerId: this.performerId
    };
  }
}
export module Performer {
  /**
   * Standard JavaScript object representation for Performer
   */
  export interface AsObject {
    performerName: string;
    performerId: number;
  }

  /**
   * Protobuf JSON representation for Performer
   */
  export interface AsProtobufJSON {
    performerName: string;
    performerId: number;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.GetPerformancesRequest
 */
export class GetPerformancesRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.GetPerformancesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPerformancesRequest();
    GetPerformancesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPerformancesRequest) {
    _instance.eventId = _instance.eventId || 0;
    _instance.startDate = _instance.startDate || undefined;
    _instance.endDate = _instance.endDate || undefined;
    _instance.performanceId = _instance.performanceId || undefined;
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPerformancesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.eventId = _reader.readInt32();
          break;
        case 2:
          _instance.startDate = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.startDate,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.endDate = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.endDate,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.performanceId = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.performanceId,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.tenantId = _reader.readString();
          break;
        case 6:
          _instance.brandId = _reader.readInt32();
          break;
        case 7:
          _instance.salesChannelId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPerformancesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPerformancesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.eventId) {
      _writer.writeInt32(1, _instance.eventId);
    }
    if (_instance.startDate) {
      _writer.writeMessage(
        2,
        _instance.startDate as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.endDate) {
      _writer.writeMessage(
        3,
        _instance.endDate as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.performanceId) {
      _writer.writeMessage(
        4,
        _instance.performanceId as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.tenantId) {
      _writer.writeString(5, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(6, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(7, _instance.salesChannelId);
    }
  }

  private _eventId: number;
  private _startDate?: googleProtobuf000.StringValue;
  private _endDate?: googleProtobuf000.StringValue;
  private _performanceId?: googleProtobuf000.Int32Value;
  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPerformancesRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPerformancesRequest.AsObject>) {
    _value = _value || {};
    this.eventId = _value.eventId;
    this.startDate = _value.startDate
      ? new googleProtobuf000.StringValue(_value.startDate)
      : undefined;
    this.endDate = _value.endDate
      ? new googleProtobuf000.StringValue(_value.endDate)
      : undefined;
    this.performanceId = _value.performanceId
      ? new googleProtobuf000.Int32Value(_value.performanceId)
      : undefined;
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    GetPerformancesRequest.refineValues(this);
  }
  get eventId(): number {
    return this._eventId;
  }
  set eventId(value: number) {
    this._eventId = value;
  }
  get startDate(): googleProtobuf000.StringValue | undefined {
    return this._startDate;
  }
  set startDate(value: googleProtobuf000.StringValue | undefined) {
    this._startDate = value;
  }
  get endDate(): googleProtobuf000.StringValue | undefined {
    return this._endDate;
  }
  set endDate(value: googleProtobuf000.StringValue | undefined) {
    this._endDate = value;
  }
  get performanceId(): googleProtobuf000.Int32Value | undefined {
    return this._performanceId;
  }
  set performanceId(value: googleProtobuf000.Int32Value | undefined) {
    this._performanceId = value;
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPerformancesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPerformancesRequest.AsObject {
    return {
      eventId: this.eventId,
      startDate: this.startDate ? this.startDate.toObject() : undefined,
      endDate: this.endDate ? this.endDate.toObject() : undefined,
      performanceId: this.performanceId
        ? this.performanceId.toObject()
        : undefined,
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPerformancesRequest.AsProtobufJSON {
    return {
      eventId: this.eventId,
      startDate: this.startDate ? this.startDate.toProtobufJSON(options) : null,
      endDate: this.endDate ? this.endDate.toProtobufJSON(options) : null,
      performanceId: this.performanceId
        ? this.performanceId.toProtobufJSON(options)
        : null,
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId
    };
  }
}
export module GetPerformancesRequest {
  /**
   * Standard JavaScript object representation for GetPerformancesRequest
   */
  export interface AsObject {
    eventId: number;
    startDate?: googleProtobuf000.StringValue.AsObject;
    endDate?: googleProtobuf000.StringValue.AsObject;
    performanceId?: googleProtobuf000.Int32Value.AsObject;
    tenantId: string;
    brandId: number;
    salesChannelId: number;
  }

  /**
   * Protobuf JSON representation for GetPerformancesRequest
   */
  export interface AsProtobufJSON {
    eventId: number;
    startDate: googleProtobuf000.StringValue.AsProtobufJSON | null;
    endDate: googleProtobuf000.StringValue.AsProtobufJSON | null;
    performanceId: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    tenantId: string;
    brandId: number;
    salesChannelId: number;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.GetPerformancesResponse
 */
export class GetPerformancesResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.GetPerformancesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPerformancesResponse();
    GetPerformancesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPerformancesResponse) {
    _instance.performances = _instance.performances || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPerformancesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new CalendarPerformance();
          _reader.readMessage(
            messageInitializer1,
            CalendarPerformance.deserializeBinaryFromReader
          );
          (_instance.performances = _instance.performances || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetPerformancesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPerformancesResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.performances && _instance.performances.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.performances as any,
        CalendarPerformance.serializeBinaryToWriter
      );
    }
  }

  private _performances?: CalendarPerformance[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPerformancesResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<GetPerformancesResponse.AsObject>) {
    _value = _value || {};
    this.performances = (_value.performances || []).map(
      m => new CalendarPerformance(m)
    );
    GetPerformancesResponse.refineValues(this);
  }
  get performances(): CalendarPerformance[] | undefined {
    return this._performances;
  }
  set performances(value: CalendarPerformance[] | undefined) {
    this._performances = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPerformancesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPerformancesResponse.AsObject {
    return {
      performances: (this.performances || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPerformancesResponse.AsProtobufJSON {
    return {
      performances: (this.performances || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetPerformancesResponse {
  /**
   * Standard JavaScript object representation for GetPerformancesResponse
   */
  export interface AsObject {
    performances?: CalendarPerformance.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetPerformancesResponse
   */
  export interface AsProtobufJSON {
    performances: CalendarPerformance.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.CalendarPerformance
 */
export class CalendarPerformance implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.CalendarPerformance';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CalendarPerformance();
    CalendarPerformance.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CalendarPerformance) {
    _instance.performanceId = _instance.performanceId || 0;
    _instance.date = _instance.date || '';
    _instance.time = _instance.time || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CalendarPerformance,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.performanceId = _reader.readInt32();
          break;
        case 2:
          _instance.date = _reader.readString();
          break;
        case 3:
          _instance.time = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CalendarPerformance.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CalendarPerformance,
    _writer: BinaryWriter
  ) {
    if (_instance.performanceId) {
      _writer.writeInt32(1, _instance.performanceId);
    }
    if (_instance.date) {
      _writer.writeString(2, _instance.date);
    }
    if (_instance.time) {
      _writer.writeString(3, _instance.time);
    }
  }

  private _performanceId: number;
  private _date: string;
  private _time: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CalendarPerformance to deeply clone from
   */
  constructor(_value?: RecursivePartial<CalendarPerformance.AsObject>) {
    _value = _value || {};
    this.performanceId = _value.performanceId;
    this.date = _value.date;
    this.time = _value.time;
    CalendarPerformance.refineValues(this);
  }
  get performanceId(): number {
    return this._performanceId;
  }
  set performanceId(value: number) {
    this._performanceId = value;
  }
  get date(): string {
    return this._date;
  }
  set date(value: string) {
    this._date = value;
  }
  get time(): string {
    return this._time;
  }
  set time(value: string) {
    this._time = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CalendarPerformance.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CalendarPerformance.AsObject {
    return {
      performanceId: this.performanceId,
      date: this.date,
      time: this.time
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CalendarPerformance.AsProtobufJSON {
    return {
      performanceId: this.performanceId,
      date: this.date,
      time: this.time
    };
  }
}
export module CalendarPerformance {
  /**
   * Standard JavaScript object representation for CalendarPerformance
   */
  export interface AsObject {
    performanceId: number;
    date: string;
    time: string;
  }

  /**
   * Protobuf JSON representation for CalendarPerformance
   */
  export interface AsProtobufJSON {
    performanceId: number;
    date: string;
    time: string;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.GetPerformanceAvailabilitiesRequest
 */
export class GetPerformanceAvailabilitiesRequest implements GrpcMessage {
  static id =
    'booking_platform.v1.entertainment.GetPerformanceAvailabilitiesRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPerformanceAvailabilitiesRequest();
    GetPerformanceAvailabilitiesRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPerformanceAvailabilitiesRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.performanceIds = _instance.performanceIds || [];
    _instance.languageCode = _instance.languageCode || '';
    _instance.currencyCode = _instance.currencyCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPerformanceAvailabilitiesRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          (_instance.performanceIds = _instance.performanceIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        case 5:
          _instance.languageCode = _reader.readString();
          break;
        case 6:
          _instance.currencyCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetPerformanceAvailabilitiesRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPerformanceAvailabilitiesRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.performanceIds && _instance.performanceIds.length) {
      _writer.writePackedInt32(4, _instance.performanceIds);
    }
    if (_instance.languageCode) {
      _writer.writeString(5, _instance.languageCode);
    }
    if (_instance.currencyCode) {
      _writer.writeString(6, _instance.currencyCode);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _performanceIds: number[];
  private _languageCode: string;
  private _currencyCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPerformanceAvailabilitiesRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetPerformanceAvailabilitiesRequest.AsObject>
  ) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.performanceIds = (_value.performanceIds || []).slice();
    this.languageCode = _value.languageCode;
    this.currencyCode = _value.currencyCode;
    GetPerformanceAvailabilitiesRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get performanceIds(): number[] {
    return this._performanceIds;
  }
  set performanceIds(value: number[]) {
    this._performanceIds = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPerformanceAvailabilitiesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPerformanceAvailabilitiesRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      performanceIds: (this.performanceIds || []).slice(),
      languageCode: this.languageCode,
      currencyCode: this.currencyCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPerformanceAvailabilitiesRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      performanceIds: (this.performanceIds || []).slice(),
      languageCode: this.languageCode,
      currencyCode: this.currencyCode
    };
  }
}
export module GetPerformanceAvailabilitiesRequest {
  /**
   * Standard JavaScript object representation for GetPerformanceAvailabilitiesRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    performanceIds: number[];
    languageCode: string;
    currencyCode: string;
  }

  /**
   * Protobuf JSON representation for GetPerformanceAvailabilitiesRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    performanceIds: number[];
    languageCode: string;
    currencyCode: string;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.GetPerformanceAvailabilitiesResponse
 */
export class GetPerformanceAvailabilitiesResponse implements GrpcMessage {
  static id =
    'booking_platform.v1.entertainment.GetPerformanceAvailabilitiesResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetPerformanceAvailabilitiesResponse();
    GetPerformanceAvailabilitiesResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetPerformanceAvailabilitiesResponse) {
    _instance.supplierPerformanceAvailabilities =
      _instance.supplierPerformanceAvailabilities || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetPerformanceAvailabilitiesResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new SupplierPerformanceAvailability();
          _reader.readMessage(
            messageInitializer1,
            SupplierPerformanceAvailability.deserializeBinaryFromReader
          );
          (_instance.supplierPerformanceAvailabilities =
            _instance.supplierPerformanceAvailabilities || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetPerformanceAvailabilitiesResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetPerformanceAvailabilitiesResponse,
    _writer: BinaryWriter
  ) {
    if (
      _instance.supplierPerformanceAvailabilities &&
      _instance.supplierPerformanceAvailabilities.length
    ) {
      _writer.writeRepeatedMessage(
        1,
        _instance.supplierPerformanceAvailabilities as any,
        SupplierPerformanceAvailability.serializeBinaryToWriter
      );
    }
  }

  private _supplierPerformanceAvailabilities?: SupplierPerformanceAvailability[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetPerformanceAvailabilitiesResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<GetPerformanceAvailabilitiesResponse.AsObject>
  ) {
    _value = _value || {};
    this.supplierPerformanceAvailabilities = (
      _value.supplierPerformanceAvailabilities || []
    ).map(m => new SupplierPerformanceAvailability(m));
    GetPerformanceAvailabilitiesResponse.refineValues(this);
  }
  get supplierPerformanceAvailabilities():
    | SupplierPerformanceAvailability[]
    | undefined {
    return this._supplierPerformanceAvailabilities;
  }
  set supplierPerformanceAvailabilities(
    value: SupplierPerformanceAvailability[] | undefined
  ) {
    this._supplierPerformanceAvailabilities = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetPerformanceAvailabilitiesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetPerformanceAvailabilitiesResponse.AsObject {
    return {
      supplierPerformanceAvailabilities: (
        this.supplierPerformanceAvailabilities || []
      ).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetPerformanceAvailabilitiesResponse.AsProtobufJSON {
    return {
      supplierPerformanceAvailabilities: (
        this.supplierPerformanceAvailabilities || []
      ).map(m => m.toProtobufJSON(options))
    };
  }
}
export module GetPerformanceAvailabilitiesResponse {
  /**
   * Standard JavaScript object representation for GetPerformanceAvailabilitiesResponse
   */
  export interface AsObject {
    supplierPerformanceAvailabilities?: SupplierPerformanceAvailability.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetPerformanceAvailabilitiesResponse
   */
  export interface AsProtobufJSON {
    supplierPerformanceAvailabilities:
      | SupplierPerformanceAvailability.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SupplierPerformanceAvailability
 */
export class SupplierPerformanceAvailability implements GrpcMessage {
  static id =
    'booking_platform.v1.entertainment.SupplierPerformanceAvailability';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SupplierPerformanceAvailability();
    SupplierPerformanceAvailability.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SupplierPerformanceAvailability) {
    _instance.performanceId = _instance.performanceId || 0;
    _instance.supplierName = _instance.supplierName || '';
    _instance.suppliersForPerformance = _instance.suppliersForPerformance || [];
    _instance.availability = _instance.availability || 0;
    _instance.redirectLink = _instance.redirectLink || undefined;
    _instance.availabilityDetails = _instance.availabilityDetails || undefined;
    _instance.fromPrice = _instance.fromPrice || undefined;
    _instance.promoCode = _instance.promoCode || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SupplierPerformanceAvailability,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.performanceId = _reader.readInt32();
          break;
        case 2:
          _instance.supplierName = _reader.readString();
          break;
        case 3:
          (_instance.suppliersForPerformance =
            _instance.suppliersForPerformance || []).push(_reader.readString());
          break;
        case 4:
          _instance.availability = _reader.readEnum();
          break;
        case 5:
          _instance.redirectLink = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.redirectLink,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.availabilityDetails = new AvailabilityDetails();
          _reader.readMessage(
            _instance.availabilityDetails,
            AvailabilityDetails.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.fromPrice = new googleType001.Decimal();
          _reader.readMessage(
            _instance.fromPrice,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.promoCode = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.promoCode,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SupplierPerformanceAvailability.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SupplierPerformanceAvailability,
    _writer: BinaryWriter
  ) {
    if (_instance.performanceId) {
      _writer.writeInt32(1, _instance.performanceId);
    }
    if (_instance.supplierName) {
      _writer.writeString(2, _instance.supplierName);
    }
    if (
      _instance.suppliersForPerformance &&
      _instance.suppliersForPerformance.length
    ) {
      _writer.writeRepeatedString(3, _instance.suppliersForPerformance);
    }
    if (_instance.availability) {
      _writer.writeEnum(4, _instance.availability);
    }
    if (_instance.redirectLink) {
      _writer.writeMessage(
        5,
        _instance.redirectLink as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.availabilityDetails) {
      _writer.writeMessage(
        6,
        _instance.availabilityDetails as any,
        AvailabilityDetails.serializeBinaryToWriter
      );
    }
    if (_instance.fromPrice) {
      _writer.writeMessage(
        7,
        _instance.fromPrice as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.promoCode) {
      _writer.writeMessage(
        8,
        _instance.promoCode as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _performanceId: number;
  private _supplierName: string;
  private _suppliersForPerformance: string[];
  private _availability: AvailabilityStatus;
  private _redirectLink?: googleProtobuf000.StringValue;
  private _availabilityDetails?: AvailabilityDetails;
  private _fromPrice?: googleType001.Decimal;
  private _promoCode?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SupplierPerformanceAvailability to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<SupplierPerformanceAvailability.AsObject>
  ) {
    _value = _value || {};
    this.performanceId = _value.performanceId;
    this.supplierName = _value.supplierName;
    this.suppliersForPerformance = (
      _value.suppliersForPerformance || []
    ).slice();
    this.availability = _value.availability;
    this.redirectLink = _value.redirectLink
      ? new googleProtobuf000.StringValue(_value.redirectLink)
      : undefined;
    this.availabilityDetails = _value.availabilityDetails
      ? new AvailabilityDetails(_value.availabilityDetails)
      : undefined;
    this.fromPrice = _value.fromPrice
      ? new googleType001.Decimal(_value.fromPrice)
      : undefined;
    this.promoCode = _value.promoCode
      ? new googleProtobuf000.StringValue(_value.promoCode)
      : undefined;
    SupplierPerformanceAvailability.refineValues(this);
  }
  get performanceId(): number {
    return this._performanceId;
  }
  set performanceId(value: number) {
    this._performanceId = value;
  }
  get supplierName(): string {
    return this._supplierName;
  }
  set supplierName(value: string) {
    this._supplierName = value;
  }
  get suppliersForPerformance(): string[] {
    return this._suppliersForPerformance;
  }
  set suppliersForPerformance(value: string[]) {
    this._suppliersForPerformance = value;
  }
  get availability(): AvailabilityStatus {
    return this._availability;
  }
  set availability(value: AvailabilityStatus) {
    this._availability = value;
  }
  get redirectLink(): googleProtobuf000.StringValue | undefined {
    return this._redirectLink;
  }
  set redirectLink(value: googleProtobuf000.StringValue | undefined) {
    this._redirectLink = value;
  }
  get availabilityDetails(): AvailabilityDetails | undefined {
    return this._availabilityDetails;
  }
  set availabilityDetails(value: AvailabilityDetails | undefined) {
    this._availabilityDetails = value;
  }
  get fromPrice(): googleType001.Decimal | undefined {
    return this._fromPrice;
  }
  set fromPrice(value: googleType001.Decimal | undefined) {
    this._fromPrice = value;
  }
  get promoCode(): googleProtobuf000.StringValue | undefined {
    return this._promoCode;
  }
  set promoCode(value: googleProtobuf000.StringValue | undefined) {
    this._promoCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SupplierPerformanceAvailability.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SupplierPerformanceAvailability.AsObject {
    return {
      performanceId: this.performanceId,
      supplierName: this.supplierName,
      suppliersForPerformance: (this.suppliersForPerformance || []).slice(),
      availability: this.availability,
      redirectLink: this.redirectLink
        ? this.redirectLink.toObject()
        : undefined,
      availabilityDetails: this.availabilityDetails
        ? this.availabilityDetails.toObject()
        : undefined,
      fromPrice: this.fromPrice ? this.fromPrice.toObject() : undefined,
      promoCode: this.promoCode ? this.promoCode.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SupplierPerformanceAvailability.AsProtobufJSON {
    return {
      performanceId: this.performanceId,
      supplierName: this.supplierName,
      suppliersForPerformance: (this.suppliersForPerformance || []).slice(),
      availability:
        AvailabilityStatus[
          this.availability === null || this.availability === undefined
            ? 0
            : this.availability
        ],
      redirectLink: this.redirectLink
        ? this.redirectLink.toProtobufJSON(options)
        : null,
      availabilityDetails: this.availabilityDetails
        ? this.availabilityDetails.toProtobufJSON(options)
        : null,
      fromPrice: this.fromPrice ? this.fromPrice.toProtobufJSON(options) : null,
      promoCode: this.promoCode ? this.promoCode.toProtobufJSON(options) : null
    };
  }
}
export module SupplierPerformanceAvailability {
  /**
   * Standard JavaScript object representation for SupplierPerformanceAvailability
   */
  export interface AsObject {
    performanceId: number;
    supplierName: string;
    suppliersForPerformance: string[];
    availability: AvailabilityStatus;
    redirectLink?: googleProtobuf000.StringValue.AsObject;
    availabilityDetails?: AvailabilityDetails.AsObject;
    fromPrice?: googleType001.Decimal.AsObject;
    promoCode?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for SupplierPerformanceAvailability
   */
  export interface AsProtobufJSON {
    performanceId: number;
    supplierName: string;
    suppliersForPerformance: string[];
    availability: string;
    redirectLink: googleProtobuf000.StringValue.AsProtobufJSON | null;
    availabilityDetails: AvailabilityDetails.AsProtobufJSON | null;
    fromPrice: googleType001.Decimal.AsProtobufJSON | null;
    promoCode: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.AvailabilityDetails
 */
export class AvailabilityDetails implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.AvailabilityDetails';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new AvailabilityDetails();
    AvailabilityDetails.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: AvailabilityDetails) {
    _instance.ticketTypes = _instance.ticketTypes || [];
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.defaultSendMethod = _instance.defaultSendMethod || undefined;
    _instance.availableSendMethods = _instance.availableSendMethods || [];
    _instance.seatPlanData = _instance.seatPlanData || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: AvailabilityDetails,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new TicketType();
          _reader.readMessage(
            messageInitializer1,
            TicketType.deserializeBinaryFromReader
          );
          (_instance.ticketTypes = _instance.ticketTypes || []).push(
            messageInitializer1
          );
          break;
        case 2:
          _instance.currencyCode = _reader.readString();
          break;
        case 3:
          _instance.defaultSendMethod = new SendMethod();
          _reader.readMessage(
            _instance.defaultSendMethod,
            SendMethod.deserializeBinaryFromReader
          );
          break;
        case 4:
          const messageInitializer4 = new SendMethod();
          _reader.readMessage(
            messageInitializer4,
            SendMethod.deserializeBinaryFromReader
          );
          (_instance.availableSendMethods =
            _instance.availableSendMethods || []).push(messageInitializer4);
          break;
        case 5:
          _instance.seatPlanData = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.seatPlanData,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    AvailabilityDetails.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: AvailabilityDetails,
    _writer: BinaryWriter
  ) {
    if (_instance.ticketTypes && _instance.ticketTypes.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.ticketTypes as any,
        TicketType.serializeBinaryToWriter
      );
    }
    if (_instance.currencyCode) {
      _writer.writeString(2, _instance.currencyCode);
    }
    if (_instance.defaultSendMethod) {
      _writer.writeMessage(
        3,
        _instance.defaultSendMethod as any,
        SendMethod.serializeBinaryToWriter
      );
    }
    if (
      _instance.availableSendMethods &&
      _instance.availableSendMethods.length
    ) {
      _writer.writeRepeatedMessage(
        4,
        _instance.availableSendMethods as any,
        SendMethod.serializeBinaryToWriter
      );
    }
    if (_instance.seatPlanData) {
      _writer.writeMessage(
        5,
        _instance.seatPlanData as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _ticketTypes?: TicketType[];
  private _currencyCode: string;
  private _defaultSendMethod?: SendMethod;
  private _availableSendMethods?: SendMethod[];
  private _seatPlanData?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of AvailabilityDetails to deeply clone from
   */
  constructor(_value?: RecursivePartial<AvailabilityDetails.AsObject>) {
    _value = _value || {};
    this.ticketTypes = (_value.ticketTypes || []).map(m => new TicketType(m));
    this.currencyCode = _value.currencyCode;
    this.defaultSendMethod = _value.defaultSendMethod
      ? new SendMethod(_value.defaultSendMethod)
      : undefined;
    this.availableSendMethods = (_value.availableSendMethods || []).map(
      m => new SendMethod(m)
    );
    this.seatPlanData = _value.seatPlanData
      ? new googleProtobuf000.StringValue(_value.seatPlanData)
      : undefined;
    AvailabilityDetails.refineValues(this);
  }
  get ticketTypes(): TicketType[] | undefined {
    return this._ticketTypes;
  }
  set ticketTypes(value: TicketType[] | undefined) {
    this._ticketTypes = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get defaultSendMethod(): SendMethod | undefined {
    return this._defaultSendMethod;
  }
  set defaultSendMethod(value: SendMethod | undefined) {
    this._defaultSendMethod = value;
  }
  get availableSendMethods(): SendMethod[] | undefined {
    return this._availableSendMethods;
  }
  set availableSendMethods(value: SendMethod[] | undefined) {
    this._availableSendMethods = value;
  }
  get seatPlanData(): googleProtobuf000.StringValue | undefined {
    return this._seatPlanData;
  }
  set seatPlanData(value: googleProtobuf000.StringValue | undefined) {
    this._seatPlanData = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    AvailabilityDetails.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): AvailabilityDetails.AsObject {
    return {
      ticketTypes: (this.ticketTypes || []).map(m => m.toObject()),
      currencyCode: this.currencyCode,
      defaultSendMethod: this.defaultSendMethod
        ? this.defaultSendMethod.toObject()
        : undefined,
      availableSendMethods: (this.availableSendMethods || []).map(m =>
        m.toObject()
      ),
      seatPlanData: this.seatPlanData ? this.seatPlanData.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): AvailabilityDetails.AsProtobufJSON {
    return {
      ticketTypes: (this.ticketTypes || []).map(m => m.toProtobufJSON(options)),
      currencyCode: this.currencyCode,
      defaultSendMethod: this.defaultSendMethod
        ? this.defaultSendMethod.toProtobufJSON(options)
        : null,
      availableSendMethods: (this.availableSendMethods || []).map(m =>
        m.toProtobufJSON(options)
      ),
      seatPlanData: this.seatPlanData
        ? this.seatPlanData.toProtobufJSON(options)
        : null
    };
  }
}
export module AvailabilityDetails {
  /**
   * Standard JavaScript object representation for AvailabilityDetails
   */
  export interface AsObject {
    ticketTypes?: TicketType.AsObject[];
    currencyCode: string;
    defaultSendMethod?: SendMethod.AsObject;
    availableSendMethods?: SendMethod.AsObject[];
    seatPlanData?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for AvailabilityDetails
   */
  export interface AsProtobufJSON {
    ticketTypes: TicketType.AsProtobufJSON[] | null;
    currencyCode: string;
    defaultSendMethod: SendMethod.AsProtobufJSON | null;
    availableSendMethods: SendMethod.AsProtobufJSON[] | null;
    seatPlanData: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.TicketType
 */
export class TicketType implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.TicketType';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new TicketType();
    TicketType.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: TicketType) {
    _instance.ticketTypeCode = _instance.ticketTypeCode || '';
    _instance.ticketTypeName = _instance.ticketTypeName || '';
    _instance.ticketTypeDescription =
      _instance.ticketTypeDescription || undefined;
    _instance.priceBands = _instance.priceBands || [];
    _instance.validQuantities = _instance.validQuantities || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: TicketType,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ticketTypeCode = _reader.readString();
          break;
        case 2:
          _instance.ticketTypeName = _reader.readString();
          break;
        case 3:
          _instance.ticketTypeDescription = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.ticketTypeDescription,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          const messageInitializer4 = new PriceBand();
          _reader.readMessage(
            messageInitializer4,
            PriceBand.deserializeBinaryFromReader
          );
          (_instance.priceBands = _instance.priceBands || []).push(
            messageInitializer4
          );
          break;
        case 5:
          (_instance.validQuantities = _instance.validQuantities || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    TicketType.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: TicketType, _writer: BinaryWriter) {
    if (_instance.ticketTypeCode) {
      _writer.writeString(1, _instance.ticketTypeCode);
    }
    if (_instance.ticketTypeName) {
      _writer.writeString(2, _instance.ticketTypeName);
    }
    if (_instance.ticketTypeDescription) {
      _writer.writeMessage(
        3,
        _instance.ticketTypeDescription as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.priceBands && _instance.priceBands.length) {
      _writer.writeRepeatedMessage(
        4,
        _instance.priceBands as any,
        PriceBand.serializeBinaryToWriter
      );
    }
    if (_instance.validQuantities && _instance.validQuantities.length) {
      _writer.writePackedInt32(5, _instance.validQuantities);
    }
  }

  private _ticketTypeCode: string;
  private _ticketTypeName: string;
  private _ticketTypeDescription?: googleProtobuf000.StringValue;
  private _priceBands?: PriceBand[];
  private _validQuantities: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of TicketType to deeply clone from
   */
  constructor(_value?: RecursivePartial<TicketType.AsObject>) {
    _value = _value || {};
    this.ticketTypeCode = _value.ticketTypeCode;
    this.ticketTypeName = _value.ticketTypeName;
    this.ticketTypeDescription = _value.ticketTypeDescription
      ? new googleProtobuf000.StringValue(_value.ticketTypeDescription)
      : undefined;
    this.priceBands = (_value.priceBands || []).map(m => new PriceBand(m));
    this.validQuantities = (_value.validQuantities || []).slice();
    TicketType.refineValues(this);
  }
  get ticketTypeCode(): string {
    return this._ticketTypeCode;
  }
  set ticketTypeCode(value: string) {
    this._ticketTypeCode = value;
  }
  get ticketTypeName(): string {
    return this._ticketTypeName;
  }
  set ticketTypeName(value: string) {
    this._ticketTypeName = value;
  }
  get ticketTypeDescription(): googleProtobuf000.StringValue | undefined {
    return this._ticketTypeDescription;
  }
  set ticketTypeDescription(value: googleProtobuf000.StringValue | undefined) {
    this._ticketTypeDescription = value;
  }
  get priceBands(): PriceBand[] | undefined {
    return this._priceBands;
  }
  set priceBands(value: PriceBand[] | undefined) {
    this._priceBands = value;
  }
  get validQuantities(): number[] {
    return this._validQuantities;
  }
  set validQuantities(value: number[]) {
    this._validQuantities = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    TicketType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): TicketType.AsObject {
    return {
      ticketTypeCode: this.ticketTypeCode,
      ticketTypeName: this.ticketTypeName,
      ticketTypeDescription: this.ticketTypeDescription
        ? this.ticketTypeDescription.toObject()
        : undefined,
      priceBands: (this.priceBands || []).map(m => m.toObject()),
      validQuantities: (this.validQuantities || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): TicketType.AsProtobufJSON {
    return {
      ticketTypeCode: this.ticketTypeCode,
      ticketTypeName: this.ticketTypeName,
      ticketTypeDescription: this.ticketTypeDescription
        ? this.ticketTypeDescription.toProtobufJSON(options)
        : null,
      priceBands: (this.priceBands || []).map(m => m.toProtobufJSON(options)),
      validQuantities: (this.validQuantities || []).slice()
    };
  }
}
export module TicketType {
  /**
   * Standard JavaScript object representation for TicketType
   */
  export interface AsObject {
    ticketTypeCode: string;
    ticketTypeName: string;
    ticketTypeDescription?: googleProtobuf000.StringValue.AsObject;
    priceBands?: PriceBand.AsObject[];
    validQuantities: number[];
  }

  /**
   * Protobuf JSON representation for TicketType
   */
  export interface AsProtobufJSON {
    ticketTypeCode: string;
    ticketTypeName: string;
    ticketTypeDescription: googleProtobuf000.StringValue.AsProtobufJSON | null;
    priceBands: PriceBand.AsProtobufJSON[] | null;
    validQuantities: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.PriceBand
 */
export class PriceBand implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.PriceBand';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PriceBand();
    PriceBand.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PriceBand) {
    _instance.ticketToken = _instance.ticketToken || '';
    _instance.priceBandCode = _instance.priceBandCode || undefined;
    _instance.ticketPrice = _instance.ticketPrice || undefined;
    _instance.ticketsAvailable = _instance.ticketsAvailable || undefined;
    _instance.isOnSale = _instance.isOnSale || false;
    _instance.onSaleStart = _instance.onSaleStart || undefined;
    _instance.onSaleEnd = _instance.onSaleEnd || undefined;
    _instance.discountCode = _instance.discountCode || undefined;
    _instance.discountDescription = _instance.discountDescription || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PriceBand,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ticketToken = _reader.readString();
          break;
        case 2:
          _instance.priceBandCode = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.priceBandCode,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.ticketPrice = new googleType001.Decimal();
          _reader.readMessage(
            _instance.ticketPrice,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.ticketsAvailable = new googleProtobuf000.Int32Value();
          _reader.readMessage(
            _instance.ticketsAvailable,
            googleProtobuf000.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.isOnSale = _reader.readBool();
          break;
        case 6:
          _instance.onSaleStart = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.onSaleStart,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.onSaleEnd = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.onSaleEnd,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.discountCode = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.discountCode,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.discountDescription = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.discountDescription,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PriceBand.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: PriceBand, _writer: BinaryWriter) {
    if (_instance.ticketToken) {
      _writer.writeString(1, _instance.ticketToken);
    }
    if (_instance.priceBandCode) {
      _writer.writeMessage(
        2,
        _instance.priceBandCode as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.ticketPrice) {
      _writer.writeMessage(
        3,
        _instance.ticketPrice as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.ticketsAvailable) {
      _writer.writeMessage(
        4,
        _instance.ticketsAvailable as any,
        googleProtobuf000.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.isOnSale) {
      _writer.writeBool(5, _instance.isOnSale);
    }
    if (_instance.onSaleStart) {
      _writer.writeMessage(
        6,
        _instance.onSaleStart as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.onSaleEnd) {
      _writer.writeMessage(
        7,
        _instance.onSaleEnd as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.discountCode) {
      _writer.writeMessage(
        8,
        _instance.discountCode as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.discountDescription) {
      _writer.writeMessage(
        9,
        _instance.discountDescription as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _ticketToken: string;
  private _priceBandCode?: googleProtobuf000.StringValue;
  private _ticketPrice?: googleType001.Decimal;
  private _ticketsAvailable?: googleProtobuf000.Int32Value;
  private _isOnSale: boolean;
  private _onSaleStart?: googleProtobuf000.StringValue;
  private _onSaleEnd?: googleProtobuf000.StringValue;
  private _discountCode?: googleProtobuf000.StringValue;
  private _discountDescription?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PriceBand to deeply clone from
   */
  constructor(_value?: RecursivePartial<PriceBand.AsObject>) {
    _value = _value || {};
    this.ticketToken = _value.ticketToken;
    this.priceBandCode = _value.priceBandCode
      ? new googleProtobuf000.StringValue(_value.priceBandCode)
      : undefined;
    this.ticketPrice = _value.ticketPrice
      ? new googleType001.Decimal(_value.ticketPrice)
      : undefined;
    this.ticketsAvailable = _value.ticketsAvailable
      ? new googleProtobuf000.Int32Value(_value.ticketsAvailable)
      : undefined;
    this.isOnSale = _value.isOnSale;
    this.onSaleStart = _value.onSaleStart
      ? new googleProtobuf000.StringValue(_value.onSaleStart)
      : undefined;
    this.onSaleEnd = _value.onSaleEnd
      ? new googleProtobuf000.StringValue(_value.onSaleEnd)
      : undefined;
    this.discountCode = _value.discountCode
      ? new googleProtobuf000.StringValue(_value.discountCode)
      : undefined;
    this.discountDescription = _value.discountDescription
      ? new googleProtobuf000.StringValue(_value.discountDescription)
      : undefined;
    PriceBand.refineValues(this);
  }
  get ticketToken(): string {
    return this._ticketToken;
  }
  set ticketToken(value: string) {
    this._ticketToken = value;
  }
  get priceBandCode(): googleProtobuf000.StringValue | undefined {
    return this._priceBandCode;
  }
  set priceBandCode(value: googleProtobuf000.StringValue | undefined) {
    this._priceBandCode = value;
  }
  get ticketPrice(): googleType001.Decimal | undefined {
    return this._ticketPrice;
  }
  set ticketPrice(value: googleType001.Decimal | undefined) {
    this._ticketPrice = value;
  }
  get ticketsAvailable(): googleProtobuf000.Int32Value | undefined {
    return this._ticketsAvailable;
  }
  set ticketsAvailable(value: googleProtobuf000.Int32Value | undefined) {
    this._ticketsAvailable = value;
  }
  get isOnSale(): boolean {
    return this._isOnSale;
  }
  set isOnSale(value: boolean) {
    this._isOnSale = value;
  }
  get onSaleStart(): googleProtobuf000.StringValue | undefined {
    return this._onSaleStart;
  }
  set onSaleStart(value: googleProtobuf000.StringValue | undefined) {
    this._onSaleStart = value;
  }
  get onSaleEnd(): googleProtobuf000.StringValue | undefined {
    return this._onSaleEnd;
  }
  set onSaleEnd(value: googleProtobuf000.StringValue | undefined) {
    this._onSaleEnd = value;
  }
  get discountCode(): googleProtobuf000.StringValue | undefined {
    return this._discountCode;
  }
  set discountCode(value: googleProtobuf000.StringValue | undefined) {
    this._discountCode = value;
  }
  get discountDescription(): googleProtobuf000.StringValue | undefined {
    return this._discountDescription;
  }
  set discountDescription(value: googleProtobuf000.StringValue | undefined) {
    this._discountDescription = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PriceBand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PriceBand.AsObject {
    return {
      ticketToken: this.ticketToken,
      priceBandCode: this.priceBandCode
        ? this.priceBandCode.toObject()
        : undefined,
      ticketPrice: this.ticketPrice ? this.ticketPrice.toObject() : undefined,
      ticketsAvailable: this.ticketsAvailable
        ? this.ticketsAvailable.toObject()
        : undefined,
      isOnSale: this.isOnSale,
      onSaleStart: this.onSaleStart ? this.onSaleStart.toObject() : undefined,
      onSaleEnd: this.onSaleEnd ? this.onSaleEnd.toObject() : undefined,
      discountCode: this.discountCode
        ? this.discountCode.toObject()
        : undefined,
      discountDescription: this.discountDescription
        ? this.discountDescription.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PriceBand.AsProtobufJSON {
    return {
      ticketToken: this.ticketToken,
      priceBandCode: this.priceBandCode
        ? this.priceBandCode.toProtobufJSON(options)
        : null,
      ticketPrice: this.ticketPrice
        ? this.ticketPrice.toProtobufJSON(options)
        : null,
      ticketsAvailable: this.ticketsAvailable
        ? this.ticketsAvailable.toProtobufJSON(options)
        : null,
      isOnSale: this.isOnSale,
      onSaleStart: this.onSaleStart
        ? this.onSaleStart.toProtobufJSON(options)
        : null,
      onSaleEnd: this.onSaleEnd ? this.onSaleEnd.toProtobufJSON(options) : null,
      discountCode: this.discountCode
        ? this.discountCode.toProtobufJSON(options)
        : null,
      discountDescription: this.discountDescription
        ? this.discountDescription.toProtobufJSON(options)
        : null
    };
  }
}
export module PriceBand {
  /**
   * Standard JavaScript object representation for PriceBand
   */
  export interface AsObject {
    ticketToken: string;
    priceBandCode?: googleProtobuf000.StringValue.AsObject;
    ticketPrice?: googleType001.Decimal.AsObject;
    ticketsAvailable?: googleProtobuf000.Int32Value.AsObject;
    isOnSale: boolean;
    onSaleStart?: googleProtobuf000.StringValue.AsObject;
    onSaleEnd?: googleProtobuf000.StringValue.AsObject;
    discountCode?: googleProtobuf000.StringValue.AsObject;
    discountDescription?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for PriceBand
   */
  export interface AsProtobufJSON {
    ticketToken: string;
    priceBandCode: googleProtobuf000.StringValue.AsProtobufJSON | null;
    ticketPrice: googleType001.Decimal.AsProtobufJSON | null;
    ticketsAvailable: googleProtobuf000.Int32Value.AsProtobufJSON | null;
    isOnSale: boolean;
    onSaleStart: googleProtobuf000.StringValue.AsProtobufJSON | null;
    onSaleEnd: googleProtobuf000.StringValue.AsProtobufJSON | null;
    discountCode: googleProtobuf000.StringValue.AsProtobufJSON | null;
    discountDescription: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SendMethod
 */
export class SendMethod implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.SendMethod';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SendMethod();
    SendMethod.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SendMethod) {
    _instance.sendMethodCode = _instance.sendMethodCode || '';
    _instance.sendMethodDescription = _instance.sendMethodDescription || '';
    _instance.cost = _instance.cost || undefined;
    _instance.allowedCountries = _instance.allowedCountries || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SendMethod,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.sendMethodCode = _reader.readString();
          break;
        case 2:
          _instance.sendMethodDescription = _reader.readString();
          break;
        case 3:
          _instance.cost = new googleType001.Decimal();
          _reader.readMessage(
            _instance.cost,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 4:
          (_instance.allowedCountries = _instance.allowedCountries || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SendMethod.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: SendMethod, _writer: BinaryWriter) {
    if (_instance.sendMethodCode) {
      _writer.writeString(1, _instance.sendMethodCode);
    }
    if (_instance.sendMethodDescription) {
      _writer.writeString(2, _instance.sendMethodDescription);
    }
    if (_instance.cost) {
      _writer.writeMessage(
        3,
        _instance.cost as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.allowedCountries && _instance.allowedCountries.length) {
      _writer.writeRepeatedString(4, _instance.allowedCountries);
    }
  }

  private _sendMethodCode: string;
  private _sendMethodDescription: string;
  private _cost?: googleType001.Decimal;
  private _allowedCountries: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SendMethod to deeply clone from
   */
  constructor(_value?: RecursivePartial<SendMethod.AsObject>) {
    _value = _value || {};
    this.sendMethodCode = _value.sendMethodCode;
    this.sendMethodDescription = _value.sendMethodDescription;
    this.cost = _value.cost
      ? new googleType001.Decimal(_value.cost)
      : undefined;
    this.allowedCountries = (_value.allowedCountries || []).slice();
    SendMethod.refineValues(this);
  }
  get sendMethodCode(): string {
    return this._sendMethodCode;
  }
  set sendMethodCode(value: string) {
    this._sendMethodCode = value;
  }
  get sendMethodDescription(): string {
    return this._sendMethodDescription;
  }
  set sendMethodDescription(value: string) {
    this._sendMethodDescription = value;
  }
  get cost(): googleType001.Decimal | undefined {
    return this._cost;
  }
  set cost(value: googleType001.Decimal | undefined) {
    this._cost = value;
  }
  get allowedCountries(): string[] {
    return this._allowedCountries;
  }
  set allowedCountries(value: string[]) {
    this._allowedCountries = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SendMethod.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SendMethod.AsObject {
    return {
      sendMethodCode: this.sendMethodCode,
      sendMethodDescription: this.sendMethodDescription,
      cost: this.cost ? this.cost.toObject() : undefined,
      allowedCountries: (this.allowedCountries || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SendMethod.AsProtobufJSON {
    return {
      sendMethodCode: this.sendMethodCode,
      sendMethodDescription: this.sendMethodDescription,
      cost: this.cost ? this.cost.toProtobufJSON(options) : null,
      allowedCountries: (this.allowedCountries || []).slice()
    };
  }
}
export module SendMethod {
  /**
   * Standard JavaScript object representation for SendMethod
   */
  export interface AsObject {
    sendMethodCode: string;
    sendMethodDescription: string;
    cost?: googleType001.Decimal.AsObject;
    allowedCountries: string[];
  }

  /**
   * Protobuf JSON representation for SendMethod
   */
  export interface AsProtobufJSON {
    sendMethodCode: string;
    sendMethodDescription: string;
    cost: googleType001.Decimal.AsProtobufJSON | null;
    allowedCountries: string[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.PerformerInfoRequest
 */
export class PerformerInfoRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.PerformerInfoRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerformerInfoRequest();
    PerformerInfoRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerformerInfoRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.performerIds = _instance.performerIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerformerInfoRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          (_instance.performerIds = _instance.performerIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PerformerInfoRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerformerInfoRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.performerIds && _instance.performerIds.length) {
      _writer.writePackedInt32(5, _instance.performerIds);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _performerIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerformerInfoRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerformerInfoRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.performerIds = (_value.performerIds || []).slice();
    PerformerInfoRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get performerIds(): number[] {
    return this._performerIds;
  }
  set performerIds(value: number[]) {
    this._performerIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerformerInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerformerInfoRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      performerIds: (this.performerIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerformerInfoRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      performerIds: (this.performerIds || []).slice()
    };
  }
}
export module PerformerInfoRequest {
  /**
   * Standard JavaScript object representation for PerformerInfoRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    performerIds: number[];
  }

  /**
   * Protobuf JSON representation for PerformerInfoRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    performerIds: number[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.PerformerInfoResponse
 */
export class PerformerInfoResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.PerformerInfoResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerformerInfoResponse();
    PerformerInfoResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerformerInfoResponse) {
    _instance.performers = _instance.performers || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerformerInfoResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new PerformerInfoEntity();
          _reader.readMessage(
            messageInitializer1,
            PerformerInfoEntity.deserializeBinaryFromReader
          );
          (_instance.performers = _instance.performers || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PerformerInfoResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerformerInfoResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.performers && _instance.performers.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.performers as any,
        PerformerInfoEntity.serializeBinaryToWriter
      );
    }
  }

  private _performers?: PerformerInfoEntity[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerformerInfoResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerformerInfoResponse.AsObject>) {
    _value = _value || {};
    this.performers = (_value.performers || []).map(
      m => new PerformerInfoEntity(m)
    );
    PerformerInfoResponse.refineValues(this);
  }
  get performers(): PerformerInfoEntity[] | undefined {
    return this._performers;
  }
  set performers(value: PerformerInfoEntity[] | undefined) {
    this._performers = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerformerInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerformerInfoResponse.AsObject {
    return {
      performers: (this.performers || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerformerInfoResponse.AsProtobufJSON {
    return {
      performers: (this.performers || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module PerformerInfoResponse {
  /**
   * Standard JavaScript object representation for PerformerInfoResponse
   */
  export interface AsObject {
    performers?: PerformerInfoEntity.AsObject[];
  }

  /**
   * Protobuf JSON representation for PerformerInfoResponse
   */
  export interface AsProtobufJSON {
    performers: PerformerInfoEntity.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.PerformerInfoEntity
 */
export class PerformerInfoEntity implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.PerformerInfoEntity';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PerformerInfoEntity();
    PerformerInfoEntity.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PerformerInfoEntity) {
    _instance.performerId = _instance.performerId || 0;
    _instance.performerName = _instance.performerName || '';
    _instance.mainImageUrl = _instance.mainImageUrl || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PerformerInfoEntity,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.performerId = _reader.readInt32();
          break;
        case 2:
          _instance.performerName = _reader.readString();
          break;
        case 3:
          _instance.mainImageUrl = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.mainImageUrl,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    PerformerInfoEntity.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PerformerInfoEntity,
    _writer: BinaryWriter
  ) {
    if (_instance.performerId) {
      _writer.writeInt32(1, _instance.performerId);
    }
    if (_instance.performerName) {
      _writer.writeString(2, _instance.performerName);
    }
    if (_instance.mainImageUrl) {
      _writer.writeMessage(
        3,
        _instance.mainImageUrl as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _performerId: number;
  private _performerName: string;
  private _mainImageUrl?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PerformerInfoEntity to deeply clone from
   */
  constructor(_value?: RecursivePartial<PerformerInfoEntity.AsObject>) {
    _value = _value || {};
    this.performerId = _value.performerId;
    this.performerName = _value.performerName;
    this.mainImageUrl = _value.mainImageUrl
      ? new googleProtobuf000.StringValue(_value.mainImageUrl)
      : undefined;
    PerformerInfoEntity.refineValues(this);
  }
  get performerId(): number {
    return this._performerId;
  }
  set performerId(value: number) {
    this._performerId = value;
  }
  get performerName(): string {
    return this._performerName;
  }
  set performerName(value: string) {
    this._performerName = value;
  }
  get mainImageUrl(): googleProtobuf000.StringValue | undefined {
    return this._mainImageUrl;
  }
  set mainImageUrl(value: googleProtobuf000.StringValue | undefined) {
    this._mainImageUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PerformerInfoEntity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PerformerInfoEntity.AsObject {
    return {
      performerId: this.performerId,
      performerName: this.performerName,
      mainImageUrl: this.mainImageUrl ? this.mainImageUrl.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PerformerInfoEntity.AsProtobufJSON {
    return {
      performerId: this.performerId,
      performerName: this.performerName,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toProtobufJSON(options)
        : null
    };
  }
}
export module PerformerInfoEntity {
  /**
   * Standard JavaScript object representation for PerformerInfoEntity
   */
  export interface AsObject {
    performerId: number;
    performerName: string;
    mainImageUrl?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for PerformerInfoEntity
   */
  export interface AsProtobufJSON {
    performerId: number;
    performerName: string;
    mainImageUrl: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.EventDetailsRequest
 */
export class EventDetailsRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.EventDetailsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EventDetailsRequest();
    EventDetailsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EventDetailsRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.languageCode = _instance.languageCode || '';
    _instance.eventId = _instance.eventId || 0;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EventDetailsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.languageCode = _reader.readString();
          break;
        case 5:
          _instance.eventId = _reader.readInt32();
          break;
        default:
          _reader.skipField();
      }
    }

    EventDetailsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EventDetailsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.languageCode) {
      _writer.writeString(4, _instance.languageCode);
    }
    if (_instance.eventId) {
      _writer.writeInt32(5, _instance.eventId);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _languageCode: string;
  private _eventId: number;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EventDetailsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<EventDetailsRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.languageCode = _value.languageCode;
    this.eventId = _value.eventId;
    EventDetailsRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }
  get eventId(): number {
    return this._eventId;
  }
  set eventId(value: number) {
    this._eventId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EventDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EventDetailsRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      eventId: this.eventId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EventDetailsRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      languageCode: this.languageCode,
      eventId: this.eventId
    };
  }
}
export module EventDetailsRequest {
  /**
   * Standard JavaScript object representation for EventDetailsRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    eventId: number;
  }

  /**
   * Protobuf JSON representation for EventDetailsRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    languageCode: string;
    eventId: number;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.EventDetailsResponse
 */
export class EventDetailsResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.EventDetailsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EventDetailsResponse();
    EventDetailsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EventDetailsResponse) {
    _instance.eventName = _instance.eventName || '';
    _instance.mainImageUrl = _instance.mainImageUrl || undefined;
    _instance.eventImages = _instance.eventImages || [];
    _instance.eventCategories = _instance.eventCategories || [];
    _instance.venue = _instance.venue || undefined;
    _instance.performers = _instance.performers || [];
    _instance.description = _instance.description || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EventDetailsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.eventName = _reader.readString();
          break;
        case 2:
          _instance.mainImageUrl = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.mainImageUrl,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          (_instance.eventImages = _instance.eventImages || []).push(
            _reader.readString()
          );
          break;
        case 4:
          (_instance.eventCategories = _instance.eventCategories || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 5:
          _instance.venue = new Venue();
          _reader.readMessage(
            _instance.venue,
            Venue.deserializeBinaryFromReader
          );
          break;
        case 6:
          const messageInitializer6 = new Performer();
          _reader.readMessage(
            messageInitializer6,
            Performer.deserializeBinaryFromReader
          );
          (_instance.performers = _instance.performers || []).push(
            messageInitializer6
          );
          break;
        case 7:
          _instance.description = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.description,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    EventDetailsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: EventDetailsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.eventName) {
      _writer.writeString(1, _instance.eventName);
    }
    if (_instance.mainImageUrl) {
      _writer.writeMessage(
        2,
        _instance.mainImageUrl as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.eventImages && _instance.eventImages.length) {
      _writer.writeRepeatedString(3, _instance.eventImages);
    }
    if (_instance.eventCategories && _instance.eventCategories.length) {
      _writer.writePackedEnum(4, _instance.eventCategories);
    }
    if (_instance.venue) {
      _writer.writeMessage(
        5,
        _instance.venue as any,
        Venue.serializeBinaryToWriter
      );
    }
    if (_instance.performers && _instance.performers.length) {
      _writer.writeRepeatedMessage(
        6,
        _instance.performers as any,
        Performer.serializeBinaryToWriter
      );
    }
    if (_instance.description) {
      _writer.writeMessage(
        7,
        _instance.description as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _eventName: string;
  private _mainImageUrl?: googleProtobuf000.StringValue;
  private _eventImages: string[];
  private _eventCategories: SearchCategory[];
  private _venue?: Venue;
  private _performers?: Performer[];
  private _description?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EventDetailsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<EventDetailsResponse.AsObject>) {
    _value = _value || {};
    this.eventName = _value.eventName;
    this.mainImageUrl = _value.mainImageUrl
      ? new googleProtobuf000.StringValue(_value.mainImageUrl)
      : undefined;
    this.eventImages = (_value.eventImages || []).slice();
    this.eventCategories = (_value.eventCategories || []).slice();
    this.venue = _value.venue ? new Venue(_value.venue) : undefined;
    this.performers = (_value.performers || []).map(m => new Performer(m));
    this.description = _value.description
      ? new googleProtobuf000.StringValue(_value.description)
      : undefined;
    EventDetailsResponse.refineValues(this);
  }
  get eventName(): string {
    return this._eventName;
  }
  set eventName(value: string) {
    this._eventName = value;
  }
  get mainImageUrl(): googleProtobuf000.StringValue | undefined {
    return this._mainImageUrl;
  }
  set mainImageUrl(value: googleProtobuf000.StringValue | undefined) {
    this._mainImageUrl = value;
  }
  get eventImages(): string[] {
    return this._eventImages;
  }
  set eventImages(value: string[]) {
    this._eventImages = value;
  }
  get eventCategories(): SearchCategory[] {
    return this._eventCategories;
  }
  set eventCategories(value: SearchCategory[]) {
    this._eventCategories = value;
  }
  get venue(): Venue | undefined {
    return this._venue;
  }
  set venue(value: Venue | undefined) {
    this._venue = value;
  }
  get performers(): Performer[] | undefined {
    return this._performers;
  }
  set performers(value: Performer[] | undefined) {
    this._performers = value;
  }
  get description(): googleProtobuf000.StringValue | undefined {
    return this._description;
  }
  set description(value: googleProtobuf000.StringValue | undefined) {
    this._description = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EventDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EventDetailsResponse.AsObject {
    return {
      eventName: this.eventName,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toObject()
        : undefined,
      eventImages: (this.eventImages || []).slice(),
      eventCategories: (this.eventCategories || []).slice(),
      venue: this.venue ? this.venue.toObject() : undefined,
      performers: (this.performers || []).map(m => m.toObject()),
      description: this.description ? this.description.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EventDetailsResponse.AsProtobufJSON {
    return {
      eventName: this.eventName,
      mainImageUrl: this.mainImageUrl
        ? this.mainImageUrl.toProtobufJSON(options)
        : null,
      eventImages: (this.eventImages || []).slice(),
      eventCategories: (this.eventCategories || []).map(v => SearchCategory[v]),
      venue: this.venue ? this.venue.toProtobufJSON(options) : null,
      performers: (this.performers || []).map(m => m.toProtobufJSON(options)),
      description: this.description
        ? this.description.toProtobufJSON(options)
        : null
    };
  }
}
export module EventDetailsResponse {
  /**
   * Standard JavaScript object representation for EventDetailsResponse
   */
  export interface AsObject {
    eventName: string;
    mainImageUrl?: googleProtobuf000.StringValue.AsObject;
    eventImages: string[];
    eventCategories: SearchCategory[];
    venue?: Venue.AsObject;
    performers?: Performer.AsObject[];
    description?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for EventDetailsResponse
   */
  export interface AsProtobufJSON {
    eventName: string;
    mainImageUrl: googleProtobuf000.StringValue.AsProtobufJSON | null;
    eventImages: string[];
    eventCategories: string[];
    venue: Venue.AsProtobufJSON | null;
    performers: Performer.AsProtobufJSON[] | null;
    description: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.Venue
 */
export class Venue implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.Venue';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new Venue();
    Venue.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: Venue) {
    _instance.venueId = _instance.venueId || 0;
    _instance.venueName = _instance.venueName || '';
    _instance.venueLocation = _instance.venueLocation || '';
    _instance.venueAddress = _instance.venueAddress || undefined;
    _instance.staticSeatmapUrl = _instance.staticSeatmapUrl || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(_instance: Venue, _reader: BinaryReader) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.venueId = _reader.readInt32();
          break;
        case 2:
          _instance.venueName = _reader.readString();
          break;
        case 3:
          _instance.venueLocation = _reader.readString();
          break;
        case 4:
          _instance.venueAddress = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.venueAddress,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.staticSeatmapUrl = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.staticSeatmapUrl,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    Venue.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: Venue, _writer: BinaryWriter) {
    if (_instance.venueId) {
      _writer.writeInt32(1, _instance.venueId);
    }
    if (_instance.venueName) {
      _writer.writeString(2, _instance.venueName);
    }
    if (_instance.venueLocation) {
      _writer.writeString(3, _instance.venueLocation);
    }
    if (_instance.venueAddress) {
      _writer.writeMessage(
        4,
        _instance.venueAddress as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.staticSeatmapUrl) {
      _writer.writeMessage(
        5,
        _instance.staticSeatmapUrl as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _venueId: number;
  private _venueName: string;
  private _venueLocation: string;
  private _venueAddress?: googleProtobuf000.StringValue;
  private _staticSeatmapUrl?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of Venue to deeply clone from
   */
  constructor(_value?: RecursivePartial<Venue.AsObject>) {
    _value = _value || {};
    this.venueId = _value.venueId;
    this.venueName = _value.venueName;
    this.venueLocation = _value.venueLocation;
    this.venueAddress = _value.venueAddress
      ? new googleProtobuf000.StringValue(_value.venueAddress)
      : undefined;
    this.staticSeatmapUrl = _value.staticSeatmapUrl
      ? new googleProtobuf000.StringValue(_value.staticSeatmapUrl)
      : undefined;
    Venue.refineValues(this);
  }
  get venueId(): number {
    return this._venueId;
  }
  set venueId(value: number) {
    this._venueId = value;
  }
  get venueName(): string {
    return this._venueName;
  }
  set venueName(value: string) {
    this._venueName = value;
  }
  get venueLocation(): string {
    return this._venueLocation;
  }
  set venueLocation(value: string) {
    this._venueLocation = value;
  }
  get venueAddress(): googleProtobuf000.StringValue | undefined {
    return this._venueAddress;
  }
  set venueAddress(value: googleProtobuf000.StringValue | undefined) {
    this._venueAddress = value;
  }
  get staticSeatmapUrl(): googleProtobuf000.StringValue | undefined {
    return this._staticSeatmapUrl;
  }
  set staticSeatmapUrl(value: googleProtobuf000.StringValue | undefined) {
    this._staticSeatmapUrl = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    Venue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): Venue.AsObject {
    return {
      venueId: this.venueId,
      venueName: this.venueName,
      venueLocation: this.venueLocation,
      venueAddress: this.venueAddress
        ? this.venueAddress.toObject()
        : undefined,
      staticSeatmapUrl: this.staticSeatmapUrl
        ? this.staticSeatmapUrl.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): Venue.AsProtobufJSON {
    return {
      venueId: this.venueId,
      venueName: this.venueName,
      venueLocation: this.venueLocation,
      venueAddress: this.venueAddress
        ? this.venueAddress.toProtobufJSON(options)
        : null,
      staticSeatmapUrl: this.staticSeatmapUrl
        ? this.staticSeatmapUrl.toProtobufJSON(options)
        : null
    };
  }
}
export module Venue {
  /**
   * Standard JavaScript object representation for Venue
   */
  export interface AsObject {
    venueId: number;
    venueName: string;
    venueLocation: string;
    venueAddress?: googleProtobuf000.StringValue.AsObject;
    staticSeatmapUrl?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for Venue
   */
  export interface AsProtobufJSON {
    venueId: number;
    venueName: string;
    venueLocation: string;
    venueAddress: googleProtobuf000.StringValue.AsProtobufJSON | null;
    staticSeatmapUrl: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.ReserveTicketsRequest
 */
export class ReserveTicketsRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.ReserveTicketsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ReserveTicketsRequest();
    ReserveTicketsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ReserveTicketsRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.performanceId = _instance.performanceId || 0;
    _instance.tickets = _instance.tickets || [];
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.ticketSendMethod = _instance.ticketSendMethod || undefined;
    _instance.languageCode = _instance.languageCode || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ReserveTicketsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.performanceId = _reader.readInt32();
          break;
        case 5:
          const messageInitializer5 = new ItemToReserve();
          _reader.readMessage(
            messageInitializer5,
            ItemToReserve.deserializeBinaryFromReader
          );
          (_instance.tickets = _instance.tickets || []).push(
            messageInitializer5
          );
          break;
        case 6:
          _instance.currencyCode = _reader.readString();
          break;
        case 7:
          _instance.ticketSendMethod = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.ticketSendMethod,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.languageCode = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.languageCode,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ReserveTicketsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ReserveTicketsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.performanceId) {
      _writer.writeInt32(4, _instance.performanceId);
    }
    if (_instance.tickets && _instance.tickets.length) {
      _writer.writeRepeatedMessage(
        5,
        _instance.tickets as any,
        ItemToReserve.serializeBinaryToWriter
      );
    }
    if (_instance.currencyCode) {
      _writer.writeString(6, _instance.currencyCode);
    }
    if (_instance.ticketSendMethod) {
      _writer.writeMessage(
        7,
        _instance.ticketSendMethod as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.languageCode) {
      _writer.writeMessage(
        8,
        _instance.languageCode as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _performanceId: number;
  private _tickets?: ItemToReserve[];
  private _currencyCode: string;
  private _ticketSendMethod?: googleProtobuf000.StringValue;
  private _languageCode?: googleProtobuf000.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ReserveTicketsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<ReserveTicketsRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.performanceId = _value.performanceId;
    this.tickets = (_value.tickets || []).map(m => new ItemToReserve(m));
    this.currencyCode = _value.currencyCode;
    this.ticketSendMethod = _value.ticketSendMethod
      ? new googleProtobuf000.StringValue(_value.ticketSendMethod)
      : undefined;
    this.languageCode = _value.languageCode
      ? new googleProtobuf000.StringValue(_value.languageCode)
      : undefined;
    ReserveTicketsRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get performanceId(): number {
    return this._performanceId;
  }
  set performanceId(value: number) {
    this._performanceId = value;
  }
  get tickets(): ItemToReserve[] | undefined {
    return this._tickets;
  }
  set tickets(value: ItemToReserve[] | undefined) {
    this._tickets = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get ticketSendMethod(): googleProtobuf000.StringValue | undefined {
    return this._ticketSendMethod;
  }
  set ticketSendMethod(value: googleProtobuf000.StringValue | undefined) {
    this._ticketSendMethod = value;
  }
  get languageCode(): googleProtobuf000.StringValue | undefined {
    return this._languageCode;
  }
  set languageCode(value: googleProtobuf000.StringValue | undefined) {
    this._languageCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ReserveTicketsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ReserveTicketsRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      performanceId: this.performanceId,
      tickets: (this.tickets || []).map(m => m.toObject()),
      currencyCode: this.currencyCode,
      ticketSendMethod: this.ticketSendMethod
        ? this.ticketSendMethod.toObject()
        : undefined,
      languageCode: this.languageCode ? this.languageCode.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ReserveTicketsRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      performanceId: this.performanceId,
      tickets: (this.tickets || []).map(m => m.toProtobufJSON(options)),
      currencyCode: this.currencyCode,
      ticketSendMethod: this.ticketSendMethod
        ? this.ticketSendMethod.toProtobufJSON(options)
        : null,
      languageCode: this.languageCode
        ? this.languageCode.toProtobufJSON(options)
        : null
    };
  }
}
export module ReserveTicketsRequest {
  /**
   * Standard JavaScript object representation for ReserveTicketsRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    performanceId: number;
    tickets?: ItemToReserve.AsObject[];
    currencyCode: string;
    ticketSendMethod?: googleProtobuf000.StringValue.AsObject;
    languageCode?: googleProtobuf000.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for ReserveTicketsRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    performanceId: number;
    tickets: ItemToReserve.AsProtobufJSON[] | null;
    currencyCode: string;
    ticketSendMethod: googleProtobuf000.StringValue.AsProtobufJSON | null;
    languageCode: googleProtobuf000.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.ItemToReserve
 */
export class ItemToReserve implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.ItemToReserve';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ItemToReserve();
    ItemToReserve.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ItemToReserve) {
    _instance.ticketToken = _instance.ticketToken || '';
    _instance.quantity = _instance.quantity || 0;
    _instance.seatCodes = _instance.seatCodes || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ItemToReserve,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ticketToken = _reader.readString();
          break;
        case 2:
          _instance.quantity = _reader.readInt32();
          break;
        case 3:
          (_instance.seatCodes = _instance.seatCodes || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    ItemToReserve.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ItemToReserve,
    _writer: BinaryWriter
  ) {
    if (_instance.ticketToken) {
      _writer.writeString(1, _instance.ticketToken);
    }
    if (_instance.quantity) {
      _writer.writeInt32(2, _instance.quantity);
    }
    if (_instance.seatCodes && _instance.seatCodes.length) {
      _writer.writeRepeatedString(3, _instance.seatCodes);
    }
  }

  private _ticketToken: string;
  private _quantity: number;
  private _seatCodes: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ItemToReserve to deeply clone from
   */
  constructor(_value?: RecursivePartial<ItemToReserve.AsObject>) {
    _value = _value || {};
    this.ticketToken = _value.ticketToken;
    this.quantity = _value.quantity;
    this.seatCodes = (_value.seatCodes || []).slice();
    ItemToReserve.refineValues(this);
  }
  get ticketToken(): string {
    return this._ticketToken;
  }
  set ticketToken(value: string) {
    this._ticketToken = value;
  }
  get quantity(): number {
    return this._quantity;
  }
  set quantity(value: number) {
    this._quantity = value;
  }
  get seatCodes(): string[] {
    return this._seatCodes;
  }
  set seatCodes(value: string[]) {
    this._seatCodes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ItemToReserve.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ItemToReserve.AsObject {
    return {
      ticketToken: this.ticketToken,
      quantity: this.quantity,
      seatCodes: (this.seatCodes || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ItemToReserve.AsProtobufJSON {
    return {
      ticketToken: this.ticketToken,
      quantity: this.quantity,
      seatCodes: (this.seatCodes || []).slice()
    };
  }
}
export module ItemToReserve {
  /**
   * Standard JavaScript object representation for ItemToReserve
   */
  export interface AsObject {
    ticketToken: string;
    quantity: number;
    seatCodes: string[];
  }

  /**
   * Protobuf JSON representation for ItemToReserve
   */
  export interface AsProtobufJSON {
    ticketToken: string;
    quantity: number;
    seatCodes: string[];
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.ReserveTicketsResponse
 */
export class ReserveTicketsResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.ReserveTicketsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ReserveTicketsResponse();
    ReserveTicketsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ReserveTicketsResponse) {
    _instance.reservedItems = _instance.reservedItems || [];
    _instance.isPriceChange = _instance.isPriceChange || false;
    _instance.ticketSendCost = _instance.ticketSendCost || undefined;
    _instance.bookToken = _instance.bookToken || '';
    _instance.tokenExpiry = _instance.tokenExpiry || '';
    _instance.allowedCountries = _instance.allowedCountries || [];
    _instance.totalPrice = _instance.totalPrice || undefined;
    _instance.termsAndConditions = _instance.termsAndConditions || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ReserveTicketsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new ReservedItem();
          _reader.readMessage(
            messageInitializer1,
            ReservedItem.deserializeBinaryFromReader
          );
          (_instance.reservedItems = _instance.reservedItems || []).push(
            messageInitializer1
          );
          break;
        case 2:
          _instance.isPriceChange = _reader.readBool();
          break;
        case 3:
          _instance.ticketSendCost = new googleType001.Decimal();
          _reader.readMessage(
            _instance.ticketSendCost,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.bookToken = _reader.readString();
          break;
        case 5:
          _instance.tokenExpiry = _reader.readString();
          break;
        case 6:
          (_instance.allowedCountries = _instance.allowedCountries || []).push(
            _reader.readString()
          );
          break;
        case 7:
          _instance.totalPrice = new googleType001.Decimal();
          _reader.readMessage(
            _instance.totalPrice,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.termsAndConditions = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    ReserveTicketsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ReserveTicketsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.reservedItems && _instance.reservedItems.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.reservedItems as any,
        ReservedItem.serializeBinaryToWriter
      );
    }
    if (_instance.isPriceChange) {
      _writer.writeBool(2, _instance.isPriceChange);
    }
    if (_instance.ticketSendCost) {
      _writer.writeMessage(
        3,
        _instance.ticketSendCost as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.bookToken) {
      _writer.writeString(4, _instance.bookToken);
    }
    if (_instance.tokenExpiry) {
      _writer.writeString(5, _instance.tokenExpiry);
    }
    if (_instance.allowedCountries && _instance.allowedCountries.length) {
      _writer.writeRepeatedString(6, _instance.allowedCountries);
    }
    if (_instance.totalPrice) {
      _writer.writeMessage(
        7,
        _instance.totalPrice as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.termsAndConditions) {
      _writer.writeString(8, _instance.termsAndConditions);
    }
  }

  private _reservedItems?: ReservedItem[];
  private _isPriceChange: boolean;
  private _ticketSendCost?: googleType001.Decimal;
  private _bookToken: string;
  private _tokenExpiry: string;
  private _allowedCountries: string[];
  private _totalPrice?: googleType001.Decimal;
  private _termsAndConditions: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ReserveTicketsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<ReserveTicketsResponse.AsObject>) {
    _value = _value || {};
    this.reservedItems = (_value.reservedItems || []).map(
      m => new ReservedItem(m)
    );
    this.isPriceChange = _value.isPriceChange;
    this.ticketSendCost = _value.ticketSendCost
      ? new googleType001.Decimal(_value.ticketSendCost)
      : undefined;
    this.bookToken = _value.bookToken;
    this.tokenExpiry = _value.tokenExpiry;
    this.allowedCountries = (_value.allowedCountries || []).slice();
    this.totalPrice = _value.totalPrice
      ? new googleType001.Decimal(_value.totalPrice)
      : undefined;
    this.termsAndConditions = _value.termsAndConditions;
    ReserveTicketsResponse.refineValues(this);
  }
  get reservedItems(): ReservedItem[] | undefined {
    return this._reservedItems;
  }
  set reservedItems(value: ReservedItem[] | undefined) {
    this._reservedItems = value;
  }
  get isPriceChange(): boolean {
    return this._isPriceChange;
  }
  set isPriceChange(value: boolean) {
    this._isPriceChange = value;
  }
  get ticketSendCost(): googleType001.Decimal | undefined {
    return this._ticketSendCost;
  }
  set ticketSendCost(value: googleType001.Decimal | undefined) {
    this._ticketSendCost = value;
  }
  get bookToken(): string {
    return this._bookToken;
  }
  set bookToken(value: string) {
    this._bookToken = value;
  }
  get tokenExpiry(): string {
    return this._tokenExpiry;
  }
  set tokenExpiry(value: string) {
    this._tokenExpiry = value;
  }
  get allowedCountries(): string[] {
    return this._allowedCountries;
  }
  set allowedCountries(value: string[]) {
    this._allowedCountries = value;
  }
  get totalPrice(): googleType001.Decimal | undefined {
    return this._totalPrice;
  }
  set totalPrice(value: googleType001.Decimal | undefined) {
    this._totalPrice = value;
  }
  get termsAndConditions(): string {
    return this._termsAndConditions;
  }
  set termsAndConditions(value: string) {
    this._termsAndConditions = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ReserveTicketsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ReserveTicketsResponse.AsObject {
    return {
      reservedItems: (this.reservedItems || []).map(m => m.toObject()),
      isPriceChange: this.isPriceChange,
      ticketSendCost: this.ticketSendCost
        ? this.ticketSendCost.toObject()
        : undefined,
      bookToken: this.bookToken,
      tokenExpiry: this.tokenExpiry,
      allowedCountries: (this.allowedCountries || []).slice(),
      totalPrice: this.totalPrice ? this.totalPrice.toObject() : undefined,
      termsAndConditions: this.termsAndConditions
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ReserveTicketsResponse.AsProtobufJSON {
    return {
      reservedItems: (this.reservedItems || []).map(m =>
        m.toProtobufJSON(options)
      ),
      isPriceChange: this.isPriceChange,
      ticketSendCost: this.ticketSendCost
        ? this.ticketSendCost.toProtobufJSON(options)
        : null,
      bookToken: this.bookToken,
      tokenExpiry: this.tokenExpiry,
      allowedCountries: (this.allowedCountries || []).slice(),
      totalPrice: this.totalPrice
        ? this.totalPrice.toProtobufJSON(options)
        : null,
      termsAndConditions: this.termsAndConditions
    };
  }
}
export module ReserveTicketsResponse {
  /**
   * Standard JavaScript object representation for ReserveTicketsResponse
   */
  export interface AsObject {
    reservedItems?: ReservedItem.AsObject[];
    isPriceChange: boolean;
    ticketSendCost?: googleType001.Decimal.AsObject;
    bookToken: string;
    tokenExpiry: string;
    allowedCountries: string[];
    totalPrice?: googleType001.Decimal.AsObject;
    termsAndConditions: string;
  }

  /**
   * Protobuf JSON representation for ReserveTicketsResponse
   */
  export interface AsProtobufJSON {
    reservedItems: ReservedItem.AsProtobufJSON[] | null;
    isPriceChange: boolean;
    ticketSendCost: googleType001.Decimal.AsProtobufJSON | null;
    bookToken: string;
    tokenExpiry: string;
    allowedCountries: string[];
    totalPrice: googleType001.Decimal.AsProtobufJSON | null;
    termsAndConditions: string;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.ReservedItem
 */
export class ReservedItem implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.ReservedItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new ReservedItem();
    ReservedItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: ReservedItem) {
    _instance.ticketToken = _instance.ticketToken || '';
    _instance.ticketTypeCode = _instance.ticketTypeCode || '';
    _instance.ticketPrice = _instance.ticketPrice || undefined;
    _instance.priceBandCode = _instance.priceBandCode || undefined;
    _instance.quantity = _instance.quantity || 0;
    _instance.seats = _instance.seats || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: ReservedItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.ticketToken = _reader.readString();
          break;
        case 2:
          _instance.ticketTypeCode = _reader.readString();
          break;
        case 3:
          _instance.ticketPrice = new googleType001.Decimal();
          _reader.readMessage(
            _instance.ticketPrice,
            googleType001.Decimal.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.priceBandCode = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.priceBandCode,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.quantity = _reader.readInt32();
          break;
        case 6:
          const messageInitializer6 = new booking_platformV1Shared004.Seat();
          _reader.readMessage(
            messageInitializer6,
            booking_platformV1Shared004.Seat.deserializeBinaryFromReader
          );
          (_instance.seats = _instance.seats || []).push(messageInitializer6);
          break;
        default:
          _reader.skipField();
      }
    }

    ReservedItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: ReservedItem,
    _writer: BinaryWriter
  ) {
    if (_instance.ticketToken) {
      _writer.writeString(1, _instance.ticketToken);
    }
    if (_instance.ticketTypeCode) {
      _writer.writeString(2, _instance.ticketTypeCode);
    }
    if (_instance.ticketPrice) {
      _writer.writeMessage(
        3,
        _instance.ticketPrice as any,
        googleType001.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.priceBandCode) {
      _writer.writeMessage(
        4,
        _instance.priceBandCode as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.quantity) {
      _writer.writeInt32(5, _instance.quantity);
    }
    if (_instance.seats && _instance.seats.length) {
      _writer.writeRepeatedMessage(
        6,
        _instance.seats as any,
        booking_platformV1Shared004.Seat.serializeBinaryToWriter
      );
    }
  }

  private _ticketToken: string;
  private _ticketTypeCode: string;
  private _ticketPrice?: googleType001.Decimal;
  private _priceBandCode?: googleProtobuf000.StringValue;
  private _quantity: number;
  private _seats?: booking_platformV1Shared004.Seat[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of ReservedItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<ReservedItem.AsObject>) {
    _value = _value || {};
    this.ticketToken = _value.ticketToken;
    this.ticketTypeCode = _value.ticketTypeCode;
    this.ticketPrice = _value.ticketPrice
      ? new googleType001.Decimal(_value.ticketPrice)
      : undefined;
    this.priceBandCode = _value.priceBandCode
      ? new googleProtobuf000.StringValue(_value.priceBandCode)
      : undefined;
    this.quantity = _value.quantity;
    this.seats = (_value.seats || []).map(
      m => new booking_platformV1Shared004.Seat(m)
    );
    ReservedItem.refineValues(this);
  }
  get ticketToken(): string {
    return this._ticketToken;
  }
  set ticketToken(value: string) {
    this._ticketToken = value;
  }
  get ticketTypeCode(): string {
    return this._ticketTypeCode;
  }
  set ticketTypeCode(value: string) {
    this._ticketTypeCode = value;
  }
  get ticketPrice(): googleType001.Decimal | undefined {
    return this._ticketPrice;
  }
  set ticketPrice(value: googleType001.Decimal | undefined) {
    this._ticketPrice = value;
  }
  get priceBandCode(): googleProtobuf000.StringValue | undefined {
    return this._priceBandCode;
  }
  set priceBandCode(value: googleProtobuf000.StringValue | undefined) {
    this._priceBandCode = value;
  }
  get quantity(): number {
    return this._quantity;
  }
  set quantity(value: number) {
    this._quantity = value;
  }
  get seats(): booking_platformV1Shared004.Seat[] | undefined {
    return this._seats;
  }
  set seats(value: booking_platformV1Shared004.Seat[] | undefined) {
    this._seats = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    ReservedItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): ReservedItem.AsObject {
    return {
      ticketToken: this.ticketToken,
      ticketTypeCode: this.ticketTypeCode,
      ticketPrice: this.ticketPrice ? this.ticketPrice.toObject() : undefined,
      priceBandCode: this.priceBandCode
        ? this.priceBandCode.toObject()
        : undefined,
      quantity: this.quantity,
      seats: (this.seats || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): ReservedItem.AsProtobufJSON {
    return {
      ticketToken: this.ticketToken,
      ticketTypeCode: this.ticketTypeCode,
      ticketPrice: this.ticketPrice
        ? this.ticketPrice.toProtobufJSON(options)
        : null,
      priceBandCode: this.priceBandCode
        ? this.priceBandCode.toProtobufJSON(options)
        : null,
      quantity: this.quantity,
      seats: (this.seats || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module ReservedItem {
  /**
   * Standard JavaScript object representation for ReservedItem
   */
  export interface AsObject {
    ticketToken: string;
    ticketTypeCode: string;
    ticketPrice?: googleType001.Decimal.AsObject;
    priceBandCode?: googleProtobuf000.StringValue.AsObject;
    quantity: number;
    seats?: booking_platformV1Shared004.Seat.AsObject[];
  }

  /**
   * Protobuf JSON representation for ReservedItem
   */
  export interface AsProtobufJSON {
    ticketToken: string;
    ticketTypeCode: string;
    ticketPrice: googleType001.Decimal.AsProtobufJSON | null;
    priceBandCode: googleProtobuf000.StringValue.AsProtobufJSON | null;
    quantity: number;
    seats: booking_platformV1Shared004.Seat.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.CancelReservationRequest
 */
export class CancelReservationRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.CancelReservationRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancelReservationRequest();
    CancelReservationRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancelReservationRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.bookToken = _instance.bookToken || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancelReservationRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.bookToken = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CancelReservationRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancelReservationRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.bookToken) {
      _writer.writeString(4, _instance.bookToken);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _bookToken: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancelReservationRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancelReservationRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.bookToken = _value.bookToken;
    CancelReservationRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get bookToken(): string {
    return this._bookToken;
  }
  set bookToken(value: string) {
    this._bookToken = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancelReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancelReservationRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookToken: this.bookToken
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancelReservationRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookToken: this.bookToken
    };
  }
}
export module CancelReservationRequest {
  /**
   * Standard JavaScript object representation for CancelReservationRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookToken: string;
  }

  /**
   * Protobuf JSON representation for CancelReservationRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookToken: string;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.CancelReservationResponse
 */
export class CancelReservationResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.CancelReservationResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancelReservationResponse();
    CancelReservationResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancelReservationResponse) {
    _instance.success = _instance.success || false;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancelReservationResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.success = _reader.readBool();
          break;
        default:
          _reader.skipField();
      }
    }

    CancelReservationResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancelReservationResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.success) {
      _writer.writeBool(1, _instance.success);
    }
  }

  private _success: boolean;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancelReservationResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancelReservationResponse.AsObject>) {
    _value = _value || {};
    this.success = _value.success;
    CancelReservationResponse.refineValues(this);
  }
  get success(): boolean {
    return this._success;
  }
  set success(value: boolean) {
    this._success = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancelReservationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancelReservationResponse.AsObject {
    return {
      success: this.success
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancelReservationResponse.AsProtobufJSON {
    return {
      success: this.success
    };
  }
}
export module CancelReservationResponse {
  /**
   * Standard JavaScript object representation for CancelReservationResponse
   */
  export interface AsObject {
    success: boolean;
  }

  /**
   * Protobuf JSON representation for CancelReservationResponse
   */
  export interface AsProtobufJSON {
    success: boolean;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SearchEventsRequest
 */
export class SearchEventsRequest implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.SearchEventsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchEventsRequest();
    SearchEventsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchEventsRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.geolocation = _instance.geolocation || undefined;
    _instance.numberOfEvents = _instance.numberOfEvents || 0;
    _instance.searchCategories = _instance.searchCategories || [];
    _instance.languageCode = _instance.languageCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchEventsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.geolocation = new booking_platformV1Shared002.Geolocation();
          _reader.readMessage(
            _instance.geolocation,
            booking_platformV1Shared002.Geolocation.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.numberOfEvents = _reader.readInt32();
          break;
        case 6:
          (_instance.searchCategories = _instance.searchCategories || []).push(
            ...(_reader.readPackedEnum() || [])
          );
          break;
        case 7:
          _instance.languageCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    SearchEventsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchEventsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.geolocation) {
      _writer.writeMessage(
        4,
        _instance.geolocation as any,
        booking_platformV1Shared002.Geolocation.serializeBinaryToWriter
      );
    }
    if (_instance.numberOfEvents) {
      _writer.writeInt32(5, _instance.numberOfEvents);
    }
    if (_instance.searchCategories && _instance.searchCategories.length) {
      _writer.writePackedEnum(6, _instance.searchCategories);
    }
    if (_instance.languageCode) {
      _writer.writeString(7, _instance.languageCode);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _geolocation?: booking_platformV1Shared002.Geolocation;
  private _numberOfEvents: number;
  private _searchCategories: SearchCategory[];
  private _languageCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchEventsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchEventsRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.geolocation = _value.geolocation
      ? new booking_platformV1Shared002.Geolocation(_value.geolocation)
      : undefined;
    this.numberOfEvents = _value.numberOfEvents;
    this.searchCategories = (_value.searchCategories || []).slice();
    this.languageCode = _value.languageCode;
    SearchEventsRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get geolocation(): booking_platformV1Shared002.Geolocation | undefined {
    return this._geolocation;
  }
  set geolocation(value: booking_platformV1Shared002.Geolocation | undefined) {
    this._geolocation = value;
  }
  get numberOfEvents(): number {
    return this._numberOfEvents;
  }
  set numberOfEvents(value: number) {
    this._numberOfEvents = value;
  }
  get searchCategories(): SearchCategory[] {
    return this._searchCategories;
  }
  set searchCategories(value: SearchCategory[]) {
    this._searchCategories = value;
  }
  get languageCode(): string {
    return this._languageCode;
  }
  set languageCode(value: string) {
    this._languageCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchEventsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchEventsRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      geolocation: this.geolocation ? this.geolocation.toObject() : undefined,
      numberOfEvents: this.numberOfEvents,
      searchCategories: (this.searchCategories || []).slice(),
      languageCode: this.languageCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchEventsRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      geolocation: this.geolocation
        ? this.geolocation.toProtobufJSON(options)
        : null,
      numberOfEvents: this.numberOfEvents,
      searchCategories: (this.searchCategories || []).map(
        v => SearchCategory[v]
      ),
      languageCode: this.languageCode
    };
  }
}
export module SearchEventsRequest {
  /**
   * Standard JavaScript object representation for SearchEventsRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    geolocation?: booking_platformV1Shared002.Geolocation.AsObject;
    numberOfEvents: number;
    searchCategories: SearchCategory[];
    languageCode: string;
  }

  /**
   * Protobuf JSON representation for SearchEventsRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    geolocation: booking_platformV1Shared002.Geolocation.AsProtobufJSON | null;
    numberOfEvents: number;
    searchCategories: string[];
    languageCode: string;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.SearchEventsResponse
 */
export class SearchEventsResponse implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.SearchEventsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SearchEventsResponse();
    SearchEventsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SearchEventsResponse) {
    _instance.eventItems = _instance.eventItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SearchEventsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new EventItem();
          _reader.readMessage(
            messageInitializer1,
            EventItem.deserializeBinaryFromReader
          );
          (_instance.eventItems = _instance.eventItems || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    SearchEventsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SearchEventsResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.eventItems && _instance.eventItems.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.eventItems as any,
        EventItem.serializeBinaryToWriter
      );
    }
  }

  private _eventItems?: EventItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SearchEventsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<SearchEventsResponse.AsObject>) {
    _value = _value || {};
    this.eventItems = (_value.eventItems || []).map(m => new EventItem(m));
    SearchEventsResponse.refineValues(this);
  }
  get eventItems(): EventItem[] | undefined {
    return this._eventItems;
  }
  set eventItems(value: EventItem[] | undefined) {
    this._eventItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SearchEventsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SearchEventsResponse.AsObject {
    return {
      eventItems: (this.eventItems || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SearchEventsResponse.AsProtobufJSON {
    return {
      eventItems: (this.eventItems || []).map(m => m.toProtobufJSON(options))
    };
  }
}
export module SearchEventsResponse {
  /**
   * Standard JavaScript object representation for SearchEventsResponse
   */
  export interface AsObject {
    eventItems?: EventItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for SearchEventsResponse
   */
  export interface AsProtobufJSON {
    eventItems: EventItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.entertainment.EventItem
 */
export class EventItem implements GrpcMessage {
  static id = 'booking_platform.v1.entertainment.EventItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new EventItem();
    EventItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: EventItem) {
    _instance.eventId = _instance.eventId || 0;
    _instance.eventName = _instance.eventName || '';
    _instance.venueLocation = _instance.venueLocation || '';
    _instance.mainImageURL = _instance.mainImageURL || undefined;
    _instance.attributeIds = _instance.attributeIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: EventItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.eventId = _reader.readInt32();
          break;
        case 2:
          _instance.eventName = _reader.readString();
          break;
        case 3:
          _instance.venueLocation = _reader.readString();
          break;
        case 4:
          _instance.mainImageURL = new googleProtobuf000.StringValue();
          _reader.readMessage(
            _instance.mainImageURL,
            googleProtobuf000.StringValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          (_instance.attributeIds = _instance.attributeIds || []).push(
            ...(_reader.readPackedInt32() || [])
          );
          break;
        default:
          _reader.skipField();
      }
    }

    EventItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: EventItem, _writer: BinaryWriter) {
    if (_instance.eventId) {
      _writer.writeInt32(1, _instance.eventId);
    }
    if (_instance.eventName) {
      _writer.writeString(2, _instance.eventName);
    }
    if (_instance.venueLocation) {
      _writer.writeString(3, _instance.venueLocation);
    }
    if (_instance.mainImageURL) {
      _writer.writeMessage(
        4,
        _instance.mainImageURL as any,
        googleProtobuf000.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.attributeIds && _instance.attributeIds.length) {
      _writer.writePackedInt32(5, _instance.attributeIds);
    }
  }

  private _eventId: number;
  private _eventName: string;
  private _venueLocation: string;
  private _mainImageURL?: googleProtobuf000.StringValue;
  private _attributeIds: number[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of EventItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<EventItem.AsObject>) {
    _value = _value || {};
    this.eventId = _value.eventId;
    this.eventName = _value.eventName;
    this.venueLocation = _value.venueLocation;
    this.mainImageURL = _value.mainImageURL
      ? new googleProtobuf000.StringValue(_value.mainImageURL)
      : undefined;
    this.attributeIds = (_value.attributeIds || []).slice();
    EventItem.refineValues(this);
  }
  get eventId(): number {
    return this._eventId;
  }
  set eventId(value: number) {
    this._eventId = value;
  }
  get eventName(): string {
    return this._eventName;
  }
  set eventName(value: string) {
    this._eventName = value;
  }
  get venueLocation(): string {
    return this._venueLocation;
  }
  set venueLocation(value: string) {
    this._venueLocation = value;
  }
  get mainImageURL(): googleProtobuf000.StringValue | undefined {
    return this._mainImageURL;
  }
  set mainImageURL(value: googleProtobuf000.StringValue | undefined) {
    this._mainImageURL = value;
  }
  get attributeIds(): number[] {
    return this._attributeIds;
  }
  set attributeIds(value: number[]) {
    this._attributeIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    EventItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): EventItem.AsObject {
    return {
      eventId: this.eventId,
      eventName: this.eventName,
      venueLocation: this.venueLocation,
      mainImageURL: this.mainImageURL
        ? this.mainImageURL.toObject()
        : undefined,
      attributeIds: (this.attributeIds || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): EventItem.AsProtobufJSON {
    return {
      eventId: this.eventId,
      eventName: this.eventName,
      venueLocation: this.venueLocation,
      mainImageURL: this.mainImageURL
        ? this.mainImageURL.toProtobufJSON(options)
        : null,
      attributeIds: (this.attributeIds || []).slice()
    };
  }
}
export module EventItem {
  /**
   * Standard JavaScript object representation for EventItem
   */
  export interface AsObject {
    eventId: number;
    eventName: string;
    venueLocation: string;
    mainImageURL?: googleProtobuf000.StringValue.AsObject;
    attributeIds: number[];
  }

  /**
   * Protobuf JSON representation for EventItem
   */
  export interface AsProtobufJSON {
    eventId: number;
    eventName: string;
    venueLocation: string;
    mainImageURL: googleProtobuf000.StringValue.AsProtobufJSON | null;
    attributeIds: number[];
  }
}
